<template>
  <div class="cfa-root">
    <c-f-a-nav :alert="alertString" contentClass="position-relative">
      <template v-slot:title>
        <div class="w-100 pt-5 text-start mb-3">
          <h1 class="cfa-section-title">{{ $t("company_title") }}</h1>
        </div>
        <br />
      </template>
      <template v-slot:content>
        <div v-show="!waitingAPIResponse" class="cfa-page">
          <div
            v-if="orgData != null"
            class="page animsition"
            style="animation-duration: 0s; opacity: 1"
          >
            <div class="card o-hidden welcome-card">
              <div class="card-body d-flex justify-content-between">
                <div>
                  <h4 class="mb-3 mt-1 f-w-500 f-22">
                    {{ $t("business_area_title") }}
                  </h4>
                  <p style="width: 100%">{{ $t("explore_text") }}</p>
                  <div class="whatsnew-btn mt-2">
                    <a
                      href="/facturation/pricing"
                      class="btn btn-outline-white"
                      >{{ $t("explore_button") }}</a
                    >
                  </div>
                </div>
              </div>
              <img
                class="welcome-img"
                src="@/assets/img/png/office-building.png"
                alt="search image"
              />
            </div>

            <div class="row">
              <div class="col-lg-12 col-xl-6">
                <div class="card course-box" style="min-height: 250px">
                  <div
                    class="card-body entreprise-block"
                    style="color: #132b4d"
                  >
                    <h5 style="color: #132b4d">{{ $t("company_code") }}</h5>
                    <br />
                    <span class="f-14 f-w-500 f-light" style="color: #132b4d">
                      {{ $t("company_code_text") }}
                    </span>
                    <br />
                    <br />
                    <div
                      class="d-flex align-items-center justify-content-between btnsss"
                      style="position: relative; margin-top: 0.8em"
                    >
                      <div class="d-flex align-items-center">
                        <a
                          @click.prevent="copyContent"
                          class="btn cfa-btn-primary btn-hover-effect rounded-0 d-flex align-items-center copy-code-btn"
                          href=""
                          style="
                            border-top-left-radius: 5px !important;
                            border-bottom-left-radius: 5px !important;
                          "
                        >
                          <i class="fa fa-copy white-color"></i>
                          {{ $t("copy_code") }}
                        </a>
                        <div
                          ref="myDiv"
                          @click="copyContent"
                          href=""
                          class="codeStyle"
                          style="
                            border-top-right-radius: 5px;
                            border-bottom-right-radius: 5px;
                          "
                        >
                          {{ orgData.code }}
                        </div>
                      </div>
                      <button
                        @click="codeConfirmBox = true"
                        class="btn cfa-btn-danger btn-hover-effect rounded-0 d-flex align-items-center change-code-btn"
                        style="border-radius: 5px !important"
                      >
                        <i class="fa fa-refresh white-color"></i>
                        {{ $t("change_code") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-xl-6">
                <div
                  class="card pe-0 get-card overflow-hidden entreprise-block"
                  style="min-height: 250px"
                >
                  <div
                    v-if="subscriptionData?.is_activated == true"
                    class="card-header card-no-border d-flex justify-content-between align-items-center"
                    style="padding: 1.5em 2em"
                  >
                    <h5>{{ $t("license") }}</h5>
                    <button
                      class="btn btn-success"
                      :style="`background-color: ${
                        subscriptionData?.is_activated ? 'green' : 'red'
                      }`"
                    >
                      {{
                        subscriptionData?.is_activated ? $t("status_active") : $t("status_expired")
                      }}
                    </button>
                  </div>
                  <div
                    v-else
                    class="card-header card-no-border d-flex justify-content-between align-items-center"
                    style="padding: 1.5em 2em"
                  >
                    <h5>{{ $t("license") }}</h5>
                    <button
                      class="btn btn-success"
                      style="background-color: rgb(255 114 94)"
                    >
                      {{ $t("no_active_plans") }}
                    </button>
                  </div>
                  <div
                    v-if="subscriptionData?.is_activated == true"
                    class="d-flex crvsce wyefwey"
                    style="padding: 0 2em 1.5em"
                  >
                    <div class="fioce">
                      <h5 class="card-title">{{ $t("plan_active") }}</h5>
                      <a
                        v-if="remain_days != ''"
                        class="btn btn-light- cfa-bg-light-primary f-light no-wrap"
                        style="pointer-events: none; position: relative"
                        v-html="lastTransactionPlan"
                      ></a>
                      <a
                        v-else
                        class="btn btn-light- cfa-bg-light-primary f-light no-wrap"
                        style="pointer-events: none; position: relative"
                        v-html="'---'"
                      ></a>
                    </div>
                    <div class="fioce">
                      <h5 class="card-title">{{ $t("remaining_days") }}</h5>
                      <a
                        v-if="remain_days != ''"
                        class="btn btn-light- cfa-bg-light-primary f-light no-wrap"
                        style="pointer-events: none; position: relative"
                        v-html="remain_days + ' ' + $t('days')"
                      ></a>
                      <a
                        v-else
                        class="btn btn-light- cfa-bg-light-primary f-light no-wrap"
                        style="pointer-events: none; position: relative"
                        v-html="'---'"
                      ></a>
                    </div>
                    <div class="fioce">
                      <h5 class="card-title">{{ $t("license-capacity") }}</h5>
                      <a
                        v-if="subscriptionData?.is_activated == true"
                        class="btn btn-light- cfa-bg-light-primary f-light no-wrap"
                        href=""
                        style="pointer-events: none; position: relative"
                      >
                        {{ subscriptionData?.nb_user }}
                        {{ $t("license-user") }}
                      </a>
                      <a
                        v-else
                        class="btn btn-light- cfa-bg-light-primary f-light no-wrap"
                        href=""
                        style="pointer-events: none; position: relative"
                      >
                        ---
                      </a>
                    </div>
                  </div>
                  <div v-else class="card-body pt-0">
                    <div class="">
                      <div
                        class="d-flex justify-content-center align-items-center oups"
                      >
                        <div class="d-flex flex-column my-4">
                          <img
                            src="@/assets/img/svg/cfa-ud-assets-05.svg"
                            alt="empty content"
                            style="width: 2.5em; margin: auto"
                          />
                          <span
                            class="mt-3 fs-5 fw-bold pl-2 text-center empty-label"
                            style="color: #132b4d"
                            >{{ $t("no_subscription") }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-lg-4"
                v-if="subscriptionData?.is_activated == true"
              >
                <div class="card course-box">
                  <div class="card-body time-block">
                    <div class="course-widget">
                      <div class="course-icon position-relative">
                        <svg class="fill-icon" style="background: #13dce6">
                          <use
                            href="http://127.0.0.1:8000/assets/svg/icon-sprite.svg#course-1"
                          ></use>
                        </svg>
                      </div>

                      <div style="width: calc(100% - 56px)">
                        <div v-if="subscriptionData?.created_at != null">
                          <h4 class="mb-0">{{ $t("subscription_activation") }}</h4>
                          <span class="f-light" style="color: ">{{
                            $t("license_activation_date")
                          }}</span>
                          <a
                            style="pointer-events: none"
                            v-if="subscriptionData != null"
                            class="btn btn-light- ff-bold cfa-bg-light-primary no-wrap white-color"
                            href=""
                            v-html="
                              convertDate(subscriptionData?.created_at, true)
                            "
                          ></a>
                          <a v-else class="btn btn-light f-light" href=""
                            >---</a
                          >
                        </div>
                        <div v-else>
                          <h4 class="mb-0">{{ $t("subscription_activation") }}</h4>
                          <span class="f-light" style="color: ">{{
                            $t("license_activation_date")
                          }}</span>
                          <a
                            style="pointer-events: none"
                            v-if="subscriptionData != null"
                            class="btn btn-light- ff-bold cfa-bg-light-primary white-color no-wrap"
                            href=""
                            v-html="'---'"
                          ></a>
                          <a v-else class="btn btn-light f-light" href=""
                            >---</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <ul class="square-group">
                    <li class="square-1 warning"></li>
                    <li class="square-1 primary"></li>
                    <li class="square-2 warning1"></li>
                    <li class="square-3 danger"></li>
                    <li class="square-4 light"></li>
                    <li class="square-5 warning"></li>
                    <li class="square-6 success"></li>
                    <li class="square-7 success"></li>
                  </ul>
                </div>
              </div>

              <div
                class="col-lg-4"
                v-if="subscriptionData?.is_activated == true"
              >
                <div class="card course-box">
                  <div class="card-body time-block">
                    <div class="course-widget">
                      <div class="course-icon warning">
                        <svg class="fill-icon">
                          <use
                            href="http://127.0.0.1:8000/assets/svg/icon-sprite.svg#course-2"
                          ></use>
                        </svg>
                      </div>

                      <div style="width: calc(100% - 56px)">
                        <div v-if="subscriptionData?.created_at != null">
                          <h4 class="mb-0">{{ $t("subscription_expiration") }}</h4>
                          <span class="f-light" style="color: #132b4d">{{
                            $t("license_expiration_date")
                          }}</span>

                          <a
                            style="pointer-events: none"
                            v-if="subscriptionData != null"
                            class="btn ff-bold cfa-bg-light-primary white-color no-wrap"
                            href=""
                            v-html="convertDate(expiration_date, true)"
                          ></a>
                          <a v-else class="btn btn-light white-color" href=""
                            >---</a
                          >
                        </div>
                        <div v-else>
                          <h4 class="mb-0">{{ $t("subscription_expiration") }}</h4>
                          <span class="f-light" style="color: #132b4d">{{
                            $t("license_expiration_date")
                          }}</span>

                          <a
                            style="pointer-events: none"
                            v-if="subscriptionData != null"
                            class="btn ff-bold cfa-bg-light-primary white-color no-wrap"
                            href=""
                            v-html="'---'"
                          ></a>
                          <a v-else class="btn btn-light white-color" href=""
                            >---</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <ul class="square-group">
                    <li class="square-1 warning"></li>
                    <li class="square-1 primary"></li>
                    <li class="square-2 warning1"></li>
                    <li class="square-3 danger"></li>
                    <li class="square-4 light"></li>
                    <li class="square-5 warning"></li>
                    <li class="square-6 success"></li>
                    <li class="square-7 success"></li>
                  </ul>
                </div>
              </div>

              <div
                class="col-lg-4"
                v-if="subscriptionData?.is_activated == true"
              >
                <div class="card course-box time-block">
                  <div class="card-body">
                    <div class="course-widget">
                      <div class="course-icon warning">
                        <svg class="fill-icon" style="background: #272f43">
                          <use
                            href="http://127.0.0.1:8000/assets/svg/icon-sprite.svg#course-2"
                          ></use>
                        </svg>
                      </div>

                      <div style="width: calc(100% - 56px)">
                        <h4 class="mb-0">{{ $t("subscription_finalisation")}}</h4>
                        <span class="f-light" style="color: #132b4d">{{
                          $t("user_finalization_date")
                        }}</span>
                        <div v-if="dateEnd != null">
                          <a
                            style="pointer-events: none"
                            v-if="subscriptionData != null"
                            class="btn ff-bold cfa-bg-light-primary white-color no-wrap"
                            href=""
                            v-html="convertDate(dateEnd, true)"
                          ></a>
                          <a v-else class="btn btn-light white-color" href=""
                            >---</a
                          >
                        </div>
                        <div v-else>
                          <a
                            style="pointer-events: none"
                            v-if="subscriptionData != null"
                            class="btn ff-bold cfa-bg-light-primary white-color no-wrap"
                            href=""
                            v-html="$t('not_defined')"
                          ></a>
                          <a v-else class="btn btn-light white-color" href=""
                            >---</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <ul class="square-group">
                    <li class="square-1 warning"></li>
                    <li class="square-1 primary"></li>
                    <li class="square-2 warning1"></li>
                    <li class="square-3 danger"></li>
                    <li class="square-4 light"></li>
                    <li class="square-5 warning"></li>
                    <li class="square-6 success"></li>
                    <li class="square-7 success"></li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="row">
              <div v-if="canSetDate()" class="col-12">
                <div
                  class="card-transparent cfa-warning-deadline py-3 px-3 mb-4"
                  style="
                    border: 2px solid var(--primary-color);
                    color: var(--primary-color);
                    font-weight: 400;
                    border-radius: 4px;
                  "
                >
                  <div
                    class="d-flex align-items-center justify-content-between w-100 efwegl"
                  >
                    <div>
                      <p
                        style="
                          font-weight: 400;
                          font-size: 1.3em;
                          color: #132b4d;
                        "
                      >
                        {{ $t("awareness_end_date") }}
                      </p>
                    </div>
                    <div class="00">
                      <VueDatePicker
                        v-model="dateEnd"
                        locale="fr"
                        :cancelText="$t('btn_cancel')"
                        :selectText="$t('btn_choose')"
                        :title="$t('set_date')"
                        :format="'dd-MM-yyyy, hh:mm:ss'"
                      ></VueDatePicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="subscriptionData?.is_activated == true">
              <div class="col-12">
                <div class="card pr-0 course-box" style="margin-bottom: 0">
                  <div class="card-body entreprise-block">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h5>{{ $t("visible_modules") }}</h5>
                        <span
                          class="f-14 f-w-500 f-light"
                          style="color: #132b4d"
                          >{{ $t("select_modules") }}</span
                        >
                      </div>
                      <div></div>
                    </div>
                    <br />
                    <div
                      class="d-flex align-items-center flex-wrap"
                      style="position: relative; top: 0.7em"
                    >
                      <div
                        class="d-flex justify-content-between w-100"
                        :style="{ padding: '1em 0.5em', margin: '0.3em' }"
                      >
                        <p class="fs-5">
                          {{ $t("check_all") }}
                        </p>
                        <label
                          class="toggle-container"
                          @click.stop="updateVisibility(modules)"
                        >
                          <input
                            type="checkbox"
                            class="toggle-input"
                            :checked="modules.every((module) => module.visible)"
                          />
                          <div class="toggle-track">
                            <span class="toggle-thumb"></span>
                          </div>
                        </label>
                      </div>
                      <div
                        v-for="(module, index) in modules"
                        :key="module.id"
                        @click.stop="toggleVisibility(module)"
                        style="width: 100%"
                      >
                        <div
                          :style="{
                            cursor: 'pointer',
                            border: '1px solid #ccc',
                            padding: '1em 0.5em',
                            margin: '0.3em',
                            borderRadius: '0.25em',
                            backgroundColor: module.visible
                              ? 'var(--primary-light-color)'
                              : 'white',
                            minWidth: '5em',
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }"
                        >
                          <span> &nbsp;&nbsp;{{ module.name }} </span>
                          <label
                            class="toggle-container"
                            @click.stop="updateVisibilities(module, index)"
                          >
                            <input
                              type="checkbox"
                              class="toggle-input"
                              :checked="module.visible"
                            />
                            <div class="toggle-track">
                              <span class="toggle-thumb"></span>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>

            <!-- Spectorly Pluzz Section -->
            <div class="row mt-4" v-if="subscriptionData?.is_activated == true">
              <div class="col-12">
                <div class="card pr-0 course-box" style="margin-bottom: 0">
                  <div class="card-body entreprise-block">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h5>{{ $t("") }}</h5>
                        <span
                          class="f-14 f-w-500 f-light"
                          style="color: #132b4d"
                          >{{ $t("modules-pluzz-subtitle") }}</span
                        >
                      </div>
                      <!-- <div>
                        <label class="toggle-container">
                          <input type="checkbox" class="toggle-input" v-model="pluzzActivated" @change="togglePluzzActivation">
                          <div class="toggle-track">
                            <span class="toggle-thumb"></span>
                          </div>
                        </label>
                      </div> -->
                    </div>
                    <br />
                    <div
                      v-if="true"
                      class="d-flex align-items-center flex-wrap"
                      style="position: relative; top: 0.7em"
                    >
                      <div
                        v-for="module in pluzzModules"
                        :key="'pluzz-' + module.id"
                        style="width: 100%"
                      >
                        <div
                          :style="{
                            border: '1px solid #ccc',
                            padding: '1em 0.5em',
                            margin: '0.3em',
                            borderRadius: '0.25em',
                            backgroundColor: module?.activated
                              ? 'var(--primary-light-color)'
                              : 'white',
                            minWidth: '5em',
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }"
                        >
                          <span> &nbsp;&nbsp;{{ module.title }} </span>
                          <div class="d-flex align-items-center">
                            <button
                              class="btn btn-outline-white"
                              type="button"
                              @click="openTargetModal(module)"
                            >
                              <i class="fa fa-bullseye me-2"></i>
                              {{ getTargetButtonText(module) }}
                            </button>
                            <!-- <label class="toggle-container ms-3">
                              <input type="checkbox" class="toggle-input" v-model="module.activated" @change="togglePluzzModule(module)">
                              <div class="toggle-track">
                                <span class="toggle-thumb"></span>
                              </div>
                            </label> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="alert alert-info mt-3">
                      {{ $t("activate_pluzz_prompt") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5" v-if="subscriptionData?.is_activated == true">
              <div class="col-12">
                <div class="card pr-0 course-box" style="margin-bottom: 0">
                  <div class="card-body entreprise-block">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h5>{{ $t("display_message_users") }}</h5>
                      </div>
                      <div></div>
                    </div>
                    <br />
                    <div
                      class="d-flex align-items-center flex-wrap"
                      style="position: relative; top: 0.7em"
                    >
                      <div
                        class="d-flex justify-content-start gap-5 w-100"
                        :style="{ padding: '1em 0.5em' }"
                      >
                        <p class="fs-5">{{ $t("enable_message_display") }}</p>
                        <label
                          class="toggle-container"
                          @click.prevent.stop="updateShowMessage"
                        >
                          <input
                            type="checkbox"
                            class="toggle-input"
                            :checked="isSetCustomMessage"
                          />
                          <div class="toggle-track">
                            <span class="toggle-thumb"></span>
                          </div>
                        </label>
                      </div>
                      <div class="w-100" :style="{ padding: '1em 0.5em' }">
                        <div class="form-group w-100">
                          <label for="customMessage" class="w-100 text-right"
                            ><strong
                              >{{ currentWordCount }} /
                              {{ maxWords }} {{ $t("words") }}</strong
                            ></label
                          >
                          <textarea
                            id="customMessage"
                            class="form-control w-100"
                            v-model="custom_message"
                            @input="enforceWordLimit"
                            rows="4"
                            :placeholder="$t('placeholder_custom_message') + ' (300 ' + $t('max_words') + ')'"
                          ></textarea>
                        </div>
                      </div>
                      <button
                        @click="updateCustomMessage"
                        id="validateButton-message"
                        class="btn btn-round cfa-btn-primary"
                      >
                        {{ $t("validate") }}
                      </button>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>

            <!-- Module Reminder Template Configuration -->
            <div class="row mt-4" v-if="subscriptionData?.is_activated == true">
              <div class="col-12">
                <div class="card pr-0 course-box" style="margin-bottom: 0">
                  <div class="card-body entreprise-block">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h5>{{ $t("module_reminder.section_title") }}</h5>
                        <span
                          class="f-14 f-w-500 f-light"
                          style="color: #132b4d"
                          >{{ $t("module_reminder.section_description") }}</span
                        >
                      </div>
                    </div>
                    <br />
                    <div
                      class="d-flex align-items-center flex-wrap"
                      style="position: relative; top: 0.7em"
                    >
                      <div
                        class="d-flex justify-content-start gap-5 w-100"
                        :style="{ padding: '1em 0.5em' }"
                      >
                        <p class="fs-5">{{ $t("module_reminder.enable_custom_reminder") }}</p>
                        <label
                          class="toggle-container"
                          @click.prevent.stop="toggleCustomReminder"
                        >
                          <input
                            type="checkbox"
                            class="toggle-input"
                            :checked="isCustomReminderEnabled"
                          />
                          <div class="toggle-track">
                            <span class="toggle-thumb"></span>
                          </div>
                        </label>
                      </div>

                      <!-- Default template message -->
                      <div v-if="!isCustomReminderEnabled" class="w-100 p-3" style="background-color: #f8f9fa; border-radius: 0.5em;">
                        <p class="text-muted mb-0">
                          <i class="fa fa-info-circle me-2"></i>
                          {{ $t("module_reminder.default_template_active") }}
                        </p>
                      </div>

                      <!-- Edit button when custom is enabled -->
                      <div v-else class="mt-3">
                        <button @click="openReminderTemplateModal" class="btn cfa-btn-primary">
                          <i class="fa fa-edit me-2"></i>
                          {{ $t("module_reminder.edit_template") }}
                        </button>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>

            <app-theme
              v-if="subscriptionData?.is_activated == true"
              @alert="
                (e) => {
                  this.alertString = e;
                }
              "
            ></app-theme>

            <div class="row">
              <div class="col-12">
                <div class="cfa-block p-4">
                  <div
                    class="d-flex align-items-center justify-content-between sfger"
                  >
                    <h5 class="mb-0">{{ $t("organization_details") }}</h5>
                    <div class="d-flex gap-2">
                      <!-- <button v-if="subscriptionData?.is_activated == true" @click="resetCustomization" class="btn cfa-btn-danger d-flex align-items-center" style="font-weight: 400;" :disabled="resetLoading">
                        <i v-if="!resetLoading" class="fa fa-refresh margin-right-10 d-none d-md-block white-color" aria-hidden="true">&nbsp;</i>
                        <span v-if="!resetLoading" class="d-inline">Réinitialiser</span>
                        <span v-else class="" style="width: 11em;">
                          <img width="20" src="@/assets/img/gif/load2.gif" alt="loader" />
                        </span>
                      </button> -->
                      <!-- <a v-if="subscriptionData?.is_activated == true" @click="openFileSelector"
                        class="btn cfa-btn-primary d-flex align-items-center" style="font-weight: 400;">
                        <i v-if="!uploadPending" class="fa fa-image margin-right-10 d-none d-md-block white-color"
                          aria-hidden="true">&nbsp;</i>
                        <span v-if="!uploadPending" class="d-inline">{{$t('define_logo')}}</span>
                        <span v-else class="" style="width: 11em;">
                          <img width="20" src="@/assets/img/gif/load2.gif" alt="loader" />
                        </span>
                      </a> -->
                      <!-- <a v-if="subscriptionData?.is_activated == true" @click="openFaviconSelector"
                        class="btn cfa-btn-secondary d-flex align-items-center" style="font-weight: 400;">
                        <i v-if="!faviconUploadPending" class="fa fa-star margin-right-10 d-none d-md-block white-color"
                          aria-hidden="true">&nbsp;</i>
                        <span v-if="!faviconUploadPending" class="d-inline">Définir Favicon</span>
                        <span v-else class="" style="width: 11em;">
                          <img width="20" src="@/assets/img/gif/load2.gif" alt="loader" />
                        </span>
                      </a> -->
                    </div>

                    <input
                      type="file"
                      accept="image/*"
                      ref="fileSelector"
                      @change="uploadImage"
                      style="display: none"
                    />
                    <input
                      type="file"
                      accept="image/*"
                      ref="faviconSelector"
                      @change="uploadFavicon"
                      style="display: none"
                    />
                  </div>
                  <div class="mt-2">
                    <section
                      v-if="subscriptionData?.is_activated == true"
                      class="text-center d-flex justify-content-center py-4"
                      style="border-radius: 0.5em"
                    >
                      <div class="d-flex gap-4 align-items-center">
                        <!-- Logo Preview -->
                        <!-- <div class="text-center">
                          <h6 class="mb-2">Logo</h6>
                          <img v-if="orgDataLogo != null" class="bg-white p-1" width="150" style="border-radius: 100%;"
                            :src="orgDataLogo" alt="logo company" />
                          <img v-else class="bg-white p-1" width="150" style="border-radius: 100%;"
                            src="@/assets/img/png/avatar.png" alt="logo company" />
                        </div> -->
                        <!-- Favicon Preview -->
                        <!-- <div class="text-center">
                          <h6 class="mb-2">Favicon</h6>
                          <img v-if="orgDataFavicon != null" class="bg-white p-1" width="64" style="border-radius: 8px;"
                            :src="orgDataFavicon" alt="favicon company" />
                          <img v-else class="bg-white p-1" width="64" style="border-radius: 8px;"
                            src="@/assets/brand/cfa-favicon1.png" alt="favicon company" />
                        </div> -->
                      </div>
                    </section>
                    <div class="row">
                      <section class="pb-0 col-12 col-md-6">
                        <form>
                          <div class="tab-pane active d-flex flex-wrap">
                            <div class="col-12">
                              <div class="form-group py-3 pe-md-2">
                                <p class="mb-2">
                                  <strong>{{ $t("structure_name") }}</strong>
                                </p>
                                <input
                                  class="form-control"
                                  type="text"
                                  disabled=""
                                  v-model="orgData.name"
                                />
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group py-3 pe-md-2">
                                <p class="mb-2">
                                  <strong>{{ $t("telephone") }}</strong>
                                </p>
                                <input-phone
                                  @updateNumber="
                                    (number) => (orgData.phone = number)
                                  "
                                  :init-value="
                                    orgData.phone.startsWith('+')
                                      ? orgData.phone
                                      : `+${orgData.phone}`
                                  "
                                />
                              </div>
                            </div>
                            <div class="col-12 pl-0">
                              <div class="form-group py-3 pe-md-2">
                                <p class="mb-2">
                                  <strong> {{ $t("pays") }}</strong>
                                </p>

                                <country
                                  class="w-full form-control"
                                  @country="
                                    (country) => (orgData.country = country[0])
                                  "
                                  :country="orgData.country"
                                  style="height: 38px"
                                />
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group py-3 pe-md-2">
                                <p class="mb-2">
                                  <strong>{{ $t("email") }}</strong>
                                </p>
                                <input
                                  class="form-control"
                                  type="text"
                                  v-model="orgData.email"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                      </section>
                      <section class="pb-0 col-12 col-md-6">
                        <form>
                          <div class="tab-pane active d-flex flex-wrap">
                            <div class="col-12">
                              <div class="form-group py-3 ps-md-2">
                                <p class="mb-2">
                                  <strong>{{
                                    $t("profile_activity_area")
                                  }}</strong>
                                </p>
                                <select
                                  class="form-control"
                                  v-model="orgData.activity"
                                  :disabled="updateLoading"
                                >
                                  <option value="" disabled>
                                    Sélectionnez un secteur d'activité
                                  </option>
                                  <option
                                    v-for="activity in activityOptions"
                                    :key="activity.id"
                                    :value="activity?.id"
                                  >
                                    {{ activity?.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group py-3 ps-md-2">
                                <p class="mb-2">
                                  <strong>{{ $t("profile_city") }}</strong>
                                </p>
                                <input
                                  class="form-control"
                                  type="text"
                                  v-model="orgData.city"
                                />
                              </div>
                            </div>
                            <div class="col-12 pl-0">
                              <div class="form-group py-3 ps-md-2">
                                <p class="mb-2">
                                  <strong>{{
                                    $t("head_office_address")
                                  }}</strong>
                                </p>
                                <input
                                  class="form-control"
                                  type="text"
                                  v-model="orgData.address"
                                />
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group py-3 ps-md-2">
                                <p class="mb-2">
                                  <strong>{{ $t("website") }}</strong>
                                </p>
                                <input
                                  class="form-control"
                                  type="text"
                                  v-model="orgData.website"
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                      </section>
                    </div>
                    <div
                      class="mt-4 d-flex justify-content-between align-items-center"
                    >
                      <div class="text-left"></div>
                      <button
                        @click="updateOrg(1)"
                        id="validateButton-pass"
                        class="btn btn-round cfa-btn-primary"
                        type="submit"
                        :disabled="updateLoading1"
                      >
                        <span v-if="!updateLoading1" class="d-inline">{{
                          $t("validate")
                        }}</span>
                        <span v-else class="" style="width: 11em">
                          <img
                            width="20"
                            src="@/assets/img/gif/load2.gif"
                            alt="loader"
                          />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="page-content" style="">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="cfa-block p-4 mt-4">
                    <div>
                      <div class="mb-4">
                        <h5>
                          {{ $t("profile_administrative_contact") }}
                        </h5>
                      </div>
                      <section>
                        <form>
                          <div>
                            <div class="col-12">
                              <div class="form-group">
                                <p class="mb-2">
                                  <strong>{{ $t("names") }}</strong>
                                </p>
                                <input
                                  class="form-control"
                                  type="text"
                                  v-model="orgData.name_administratif"
                                />
                              </div>
                            </div>
                            <div class="row d-flex align-items-center">
                              <div class="col-6">
                                <div class="form-group">
                                  <p class="mb-2">
                                    <strong>{{ $t("email") }}</strong>
                                  </p>
                                  <input
                                    class="form-control"
                                    type="text"
                                    v-model="orgData.email_administratif"
                                  />
                                </div>
                              </div>
                              <div class="col-6 pl-0">
                                <div class="form-group py-3 pe-0 pe-md-2">
                                  <p class="mb-2">
                                    <strong>{{ $t("telephone") }}</strong>
                                  </p>

                                  <input-phone
                                    @updateNumber="
                                      (number) =>
                                        (orgData.phone_administratif = number)
                                    "
                                    :init-value="
                                      orgData.phone_administratif &&
                                      orgData.phone_administratif.startsWith(
                                        '+'
                                      )
                                        ? orgData.phone_administratif
                                        : `${
                                            orgData.phone_administratif
                                              ? orgData.phone_administratif
                                              : ''
                                          }`
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </section>
                      <div class="col-12 pl-0">
                        <div class="form-group py-3 pe-0 pe-md-2">
                          <p class="mb-2"><strong>&nbsp;</strong></p>
                          <div class="d-flex justify-content-end">
                            <button
                              @click="updateOrg(2)"
                              id="validateButton-pass"
                              class="btn btn-round cfa-btn-primary"
                              type="submit"
                              :disabled="updateLoading2"
                            >
                              <span v-if="!updateLoading2" class="d-inline">{{
                                $t("validate")
                              }}</span>
                              <span v-else class="" style="width: 11em">
                                <img
                                  width="20"
                                  src="@/assets/img/gif/load2.gif"
                                  alt="loader"
                                />
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="cfa-block p-4 mt-4">
                    <div>
                      <h5>{{ $t("billing_contact") }}</h5>
                      <div>
                        <form>
                          <div>
                            <div class="col-12">
                              <div class="form-group py-2 ps-md-2">
                                <p class="mb-2">
                                  <strong>{{ $t("organization_name") }}</strong>
                                </p>
                                <input
                                  class="form-control"
                                  type="text"
                                  v-model="orgData.name"
                                />
                              </div>
                            </div>
                            <div class="row d-flex align-items-center">
                              <div class="col-6">
                                <div class="form-group">
                                  <p class="mb-2">
                                    <strong>{{ $t("email") }}</strong>
                                  </p>
                                  <input
                                    class="form-control"
                                    type="text"
                                    v-model="orgData.email_facturation"
                                  />
                                </div>
                              </div>
                              <div class="col-6 pl-0">
                                <div class="form-group py-3 pe-0 pe-md-2">
                                  <p class="mb-2">
                                    <strong>{{ $t("telephone") }}</strong>
                                  </p>
                                  <!-- <input class="form-control" type="text" v-model="orgData.phone"> -->
                                  <input-phone
                                    @updateNumber="
                                      (number) => (orgData.phone = number)
                                    "
                                    :init-value="
                                      orgData.phone.startsWith('+')
                                        ? orgData.phone
                                        : `+${orgData.phone}`
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-12 pl-0">
                              <div class="form-group py-3 pe-0 pe-md-2">
                                <p class="mb-0"><strong>&nbsp;</strong></p>
                                <div class="d-flex justify-content-end">
                                  <button
                                    @click="updateOrg(3)"
                                    id="validateButton-pass"
                                    class="btn btn-round cfa-btn-primary"
                                    type="button"
                                    :disabled="updateLoading3"
                                  >
                                    <span
                                      v-if="!updateLoading3"
                                      class="d-inline"
                                      >{{ $t("validate") }}</span
                                    >
                                    <span v-else class="" style="width: 11em">
                                      <img
                                        width="20"
                                        src="@/assets/img/gif/load2.gif"
                                        alt="loader"
                                      />
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- SSO Configuration - Managers only -->
             <div class="row mt-3" v-if="isManager">
              <div class="col-lg-12 col-xl-6">
                <div class="card course-box" style="min-height: 300px">
                  <div
                    class="card-body entreprise-block"
                    style="color: #132b4d"
                  >
                    <div
                      class="d-flex justify-content-between align-items-center mb-3"
                    >
                      <h5 style="color: #132b4d">{{ $t("sso_configuration") }}</h5>
                      <label
                        class="toggle-container"
                        @click.stop="toggleSSOStatus"
                      >
                        <input
                          type="checkbox"
                          class="toggle-input"
                          :checked="ssoEnabled"
                        />
                        <div class="toggle-track">
                          <span class="toggle-thumb"></span>
                        </div>
                      </label>
                    </div>
                    <span class="f-14 f-w-500 f-light" style="color: #132b4d">
                      {{
                        ssoEnabled
                          ? $t("sso_enabled_message")
                          : $t("sso_disabled_message")
                      }}
                    </span>
                    <br /><br />

                    <div
                      class="d-flex align-items-center mb-3"
                      style="gap: 12px"
                    >
                      <select
                        class="form-control"
                        v-model="selectedProvider"
                        @change="onProviderChange"
                        style="max-width: 320px"
                      >
                        <option :value="null" disabled>
                          {{ $t("choose_provider") }}
                        </option>
                        <option
                          v-for="option in providerOptions"
                          :key="option.value"
                          :value="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                      <button
                        v-if="hasSSOConfiguration"
                        class="btn cfa-btn-secondary btn-hover-effect"
                        :disabled="!selectedProvider || savingSSO"
                        @click="updateSSOConfiguration"
                      >
                        <span v-if="!savingSSO">{{ $t("update_btn") }}</span>
                        <span v-else>{{ $t("updating") }}</span>
                      </button>
                      <button
                        v-else
                        class="btn cfa-btn-primary btn-hover-effect"
                        :disabled="!selectedProvider || savingSSO"
                        @click="saveSSOConfiguration"
                      >
                        <span v-if="!savingSSO">{{ $t("configure_sso") }}</span>
                        <span v-else>{{ $t("configuring") }}</span>
                      </button>
                    </div>

                    <div v-if="ssoEnabled" class="mt-3">
                      <h6 style="color: #132b4d; margin-bottom: 10px">
                        {{ $t("authorized_domains") }}
                      </h6>
                      <div
                        class="d-flex align-items-center mb-2"
                        style="gap: 8px"
                      >
                        <input
                          type="text"
                          v-model="selectedDomainToAdd"
                          class="form-control"
                          placeholder="Entrez un domaine"
                          style="max-width: 200px"
                        />
                        <button
                          class="btn btn-sm cfa-btn-secondary"
                          @click="addDomain"
                          :disabled="!selectedDomainToAdd"
                        >
                          Ajouter
                        </button>
                      </div>
                      <div v-if="domains.length > 0" class="domain-list mt-3">
                        <h6 style="color: #132b4d; margin-bottom: 10px; font-size: 14px;">
                          Domaines autorisés pour SSO
                        </h6>
                        <div
                          v-for="(domain, index) in domains"
                          :key="index"
                          class="d-flex align-items-center justify-content-between mb-1"
                          style="
                            padding: 4px 8px;
                            background: #f8f9fa;
                            border-radius: 4px;
                          "
                        >
                          <span class="f-14">{{ domain.domain }}</span>
                          <button
                            class="btn btn-sm btn-outline-danger"
                            @click="removeDomain(index)"
                            style="padding: 2px 6px"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Right Column: Email Domains List -->
              <div class="col-lg-12 col-xl-6" v-if="ssoEnabled">
                <div class="card course-box">
                  <div
                    class="card-body entreprise-block"
                    style="color: #132b4d"
                  >
                    <h5 style="color: #132b4d; margin-bottom: 20px">
                      Domaines d'e-mail de l'organisation
                    </h5>
                    <div v-if="availableEmailDomains.length > 0" class="domain-list">
                      <div
                        v-for="domain in availableEmailDomains"
                        :key="domain.id"
                        class="d-flex align-items-center justify-content-between mb-2"
                        style="
                          padding: 8px 12px;
                          background: #f8f9fa;
                          border-radius: 4px;
                        "
                      >
                        <span class="f-14">{{ domain.domain }}</span>
                        <div style="gap: 8px; display: flex;">
                          <button
                            class="btn btn-sm btn-outline-primary"
                            @click="openEditDomainModal(domain)"
                            style="padding: 4px 12px"
                          >
                            <i class="fa fa-edit"></i> Modifier
                          </button>
                          <button
                            class="btn btn-sm btn-outline-danger"
                            @click="openDeleteDomainModal(domain)"
                            style="padding: 4px 12px"
                          >
                            <i class="fa fa-trash"></i> Supprimer
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-else class="mt-2">
                      <p class="text-muted f-14">Aucun domaine d'e-mail configuré</p>
                    </div>
                  </div>
                </div>
              </div>
            </div> 

            <!-- MS Teams Configuration - Managers only -->
            <!-- <div class="row mt-3" v-if="isManager">
              <div class="col-12">
                <div class="card course-box">
                  <div class="card-body entreprise-block" style="color: #132b4d">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0" style="color: #132b4d">
                        <i class="fa fa-users me-2" style="color: #0bbbc4"></i>
                        {{ $t("ms_teams_credentials") }}
                      </h5>
                      <div class="d-flex align-items-center">
                        <button v-if="teamsCredentials.id" class="btn btn-outline-danger me-2" @click="showTeamsDeleteModal = true">
                          <i class="fa fa-trash me-1"></i> {{ $t("ms_teams_delete") }}
                        </button>
                        <button class="btn cfa-btn-primary" @click="showTeamsModal = true">
                          <i class="fa" :class="teamsCredentials.id ? 'fa-edit' : 'fa-plus'"></i> 
                          {{ teamsCredentials.id ? $t("ms_teams_update") : $t("add") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>  -->

            <div class="row mt-3" v-if="subscriptionData?.is_activated == true">
              <div class="col-12">
                <div class="cfa-block p-4">
                  <div>
                    <h5 class="mb-0">{{ $t("reset_customizations") }}</h5>
                  </div>
                  <p class="mt-2">
                    {{ $t("reset_customizations_description") }}
                  </p>
                  <div class="mt-2">
                    <button
                      @click="resetConfirmBox = true"
                      class="btn cfa-btn-danger d-flex align-items-center"
                      style="font-weight: 400"
                      :disabled="resetLoading"
                    >
                      <i
                        v-if="!resetLoading"
                        class="fa fa-refresh margin-right-10 d-none d-md-block white-color"
                        aria-hidden="true"
                        >&nbsp;</i
                      >
                      <span v-if="!resetLoading" class="d-inline"
                        >{{ $t("common.reset") }}</span
                      >
                      <span v-else class="" style="width: 11em">
                        <img
                          width="20"
                          src="@/assets/img/gif/load2.gif"
                          alt="loader"
                        />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              class="d-flex justify-content-center align-items-center oups"
              style="min-height: 70vh"
            >
              <div class="preloader_center d-flex flex-column">
                <img
                  src="@/assets/img/svg/cfa-ud-assets-13.svg"
                  alt="cfa empty section"
                  style="width: 22em"
                />
                <h3 class="pl-3 mt-3">
                  Vous n'appartenez à aucune organisation !
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div v-show="waitingAPIResponse" class="cfa-page">
          <div
            class="d-flex justify-content-center align-items-center oups"
            style="min-height: 70vh"
          >
            <div class="loader-pulse">
              <div class="logo-placeholder">
                <img
                  src="../../assets/brand/cfa-favicon1.png"
                  alt="cfa preloader"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </c-f-a-nav>
    <c-f-a-footer></c-f-a-footer>
    <scalable-modal
      @callback="updateCode"
      :break="exitCodeModal"
      :uid="'code-confirmation-modal'"
      @close="codeConfirmBox = false"
      :open="codeConfirmBox"
      :advancedControl="true"
      :validationButtonText="$t('modal_yes')"
      :exitButtonText="$t('modal_no')"
      displayMode="flex"
      :style="'width: 30em; height: 22em;'"
    >
      <template v-slot:content>
        <div class="col-12 pl-0">
          <div class="form-group py-3 pe-0 pe-md-2">
            <p class="mb-2">
              <strong>{{ $t("regenerate_code_confirm") }}</strong
              >
            </p>
          </div>
        </div>
      </template>
    </scalable-modal>
    <scalable-modal
      @callback="updateReset"
      :break="exitResetModal"
      :uid="'reset-confirmation-modal'"
      @close="resetConfirmBox = false"
      :open="resetConfirmBox"
      :advancedControl="true"
      :validationButtonText="$t('modal_yes')"
      :exitButtonText="$t('modal_no')"
      displayMode="flex"
      :style="'width: 30em; height: 22em;'"
    >
      <template v-slot:content>
        <div class="col-12 pl-0">
          <div class="form-group py-3 pe-0 pe-md-2">
            <p class="mb-2">
              <strong>{{ $t("reset_customization_confirm") }}</strong
              >
            </p>
          </div>
        </div>
      </template>
    </scalable-modal>
    <scalable-modal
      @callback="updateModulePluzzTarget"
      :break="exitPluzzTargetModal"
      :uid="'pluzz-modal'"
      @close="updatePluzzTargetBox = false"
      :open="updatePluzzTargetBox"
      :advancedControl="true"
      :validationButtonText="$t('modal_update')"
      displayMode="flex"
      :style="'width: 50em;'"
      disable-control
    >
      <template v-slot:content>
        <!-- Toggle Header -->
        <div class="pluzz-modal-header">
          <div
            class="d-flex justify-content-between align-items-center p-3 bg-light rounded"
          >
            <div class="d-flex align-items-center gap-3">
              <i class="fa fa-users-cog fs-4 text-primary"></i>
              <div>
                <p class="mb-0 fw-bold fs-6">
                  {{ $t("all_users_access") }}
                </p>
                <small class="text-muted"
                  >{{ $t("all_users_access_desc") }}</small
                >
              </div>
            </div>
            <label class="toggle-container">
              <input
                type="checkbox"
                class="toggle-input"
                @change="updateAllAccess"
                v-model="moduleToUpdateAll"
              />
              <div class="toggle-track">
                <span class="toggle-thumb"></span>
              </div>
            </label>
          </div>
        </div>

        <!-- Tabs and Content -->
        <div class="pluzz-modal-body mt-4">
          <!-- Tabs -->
          <div class="pluzz-tabs-container mb-3">
            <button
              class="pluzz-tab-button"
              :class="{
                active: activePluzzTab === 'groups',
                disabled: selectedPluzz.services.length > 0,
              }"
              :disabled="selectedPluzz.services.length > 0"
              @click="activePluzzTab = 'groups'"
            >
              <i class="fa fa-users me-2"></i>{{ $t("groups") }}
              <span
                v-if="selectedPluzz.groups.length > 0"
                class="badge bg-primary ms-2"
                >{{ selectedPluzz.groups.length }}</span
              >
            </button>
            <button
              class="pluzz-tab-button"
              :class="{
                active: activePluzzTab === 'services',
                disabled: selectedPluzz.groups.length > 0,
              }"
              :disabled="selectedPluzz.groups.length > 0"
              @click="activePluzzTab = 'services'"
            >
              <i class="fa fa-briefcase me-2"></i>{{ $t("services") }}
              <span
                v-if="selectedPluzz.services.length > 0"
                class="badge bg-primary ms-2"
                >{{ selectedPluzz.services.length }}</span
              >
            </button>
          </div>

          <!-- Tab Content -->
          <div class="pluzz-tab-content">
            <!-- Groups Tab -->
            <div v-show="activePluzzTab === 'groups'" class="tab-pane-content">
              <div
                v-if="paginatedGroups.length === 0"
                class="empty-state-pluzz"
              >
                <i class="fa fa-users fa-3x mb-3 text-muted"></i>
                <p class="text-muted mb-0">{{ $t("no_groups_available") }}</p>
              </div>
              <div v-else class="selection-list-pluzz">
                <div
                  v-for="group in paginatedGroups"
                  :key="group.id"
                  class="pluzz-selection-item"
                  :class="{ selected: selectedPluzz.groups.includes(group.id) }"
                >
                  <input
                    type="checkbox"
                    :id="'pluzz-group-' + group.id"
                    :value="group.id"
                    v-model="selectedPluzz.groups"
                    class="pluzz-checkbox"
                  />
                  <label :for="'pluzz-group-' + group.id" class="pluzz-label">
                    <div class="pluzz-item-info">
                      <strong class="pluzz-item-name">{{ group.name }}</strong>
                      <small class="text-muted"
                        >{{ group.users?.length || 0 }} {{ $t("users_count") }}</small
                      >
                    </div>
                  </label>
                </div>
              </div>

              <!-- Pagination -->
              <nav class="w-100 mt-3" v-if="paginatedGroups.length > 0">
                <ul
                  class="pagination justify-content-center align-items-center gap-2"
                >
                  <li>
                    <button
                      class="btn btn-sm cfa-btn-light"
                      @click="prevPage('groups')"
                      :disabled="currentPageGroups === 1"
                    >
                      <i class="fa fa-chevron-left"></i> {{ $t("pagination_previous") }}
                    </button>
                  </li>
                  <li class="px-3">
                    <span class="fw-bold"
                      >{{ currentPageGroups }} / {{ totalGroupsPages }}</span
                    >
                  </li>
                  <li>
                    <button
                      class="btn btn-sm cfa-btn-primary"
                      @click="nextPage('groups')"
                      :disabled="currentPageGroups === totalGroupsPages"
                    >
                      {{ $t("pagination_next") }} <i class="fa fa-chevron-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>

            <!-- Services Tab -->
            <div
              v-show="activePluzzTab === 'services'"
              class="tab-pane-content"
            >
              <div
                v-if="paginatedServices.length === 0"
                class="empty-state-pluzz"
              >
                <i class="fa fa-briefcase fa-3x mb-3 text-muted"></i>
                <p class="text-muted mb-0">{{ $t("no_services_available") }}</p>
              </div>
              <div v-else class="selection-list-pluzz">
                <div
                  v-for="service in paginatedServices"
                  :key="service.id"
                  class="pluzz-selection-item"
                  :class="{
                    selected: selectedPluzz.services.includes(service.id),
                  }"
                >
                  <input
                    type="checkbox"
                    :id="'pluzz-services-' + service.id"
                    :value="service.id"
                    v-model="selectedPluzz.services"
                    class="pluzz-checkbox"
                  />
                  <label
                    :for="'pluzz-services-' + service.id"
                    class="pluzz-label"
                  >
                    <div class="pluzz-item-info">
                      <strong class="pluzz-item-name">{{
                        service.name
                      }}</strong>
                      <small class="text-muted">{{ $t("service_label") }}</small>
                    </div>
                  </label>
                </div>
              </div>

              <!-- Pagination -->
              <nav class="w-100 mt-3" v-if="paginatedServices.length > 0">
                <ul
                  class="pagination justify-content-center align-items-center gap-2"
                >
                  <li>
                    <button
                      class="btn btn-sm cfa-btn-light"
                      @click="prevPage('services')"
                      :disabled="currentPageServices === 1"
                    >
                      <i class="fa fa-chevron-left"></i> {{ $t("pagination_previous") }}
                    </button>
                  </li>
                  <li class="px-3">
                    <span class="fw-bold"
                      >{{ currentPageServices }} /
                      {{ totalServicesPages }}</span
                    >
                  </li>
                  <li>
                    <button
                      class="btn btn-sm cfa-btn-primary"
                      @click="nextPage('services')"
                      :disabled="currentPageServices === totalServicesPages"
                    >
                      {{ $t("pagination_next") }} <i class="fa fa-chevron-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>

          <!-- Selection Summary -->
          <div class="pluzz-selection-summary mt-4 p-3 bg-light rounded">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <strong class="text-primary">{{ $t("selection") }}</strong>
                <span class="ms-2">
                  <i class="fa fa-users me-1"></i
                  >{{ selectedPluzz.groups.length }} {{ $t("groups_count") }}
                  <span class="mx-2">•</span>
                  <i class="fa fa-briefcase me-1"></i
                  >{{ selectedPluzz.services.length }} {{ $t("services_count") }}
                </span>
              </div>
              <strong class="text-primary"
                >{{ $t("total") }}
                {{
                  selectedPluzz.groups.length + selectedPluzz.services.length
                }}</strong
              >
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            class="btn cfa-btn-primary px-4 py-2"
            @click="updateModulePluzzTarget(true)"
            :disabled="isUpdatingPluzz"
          >
            <template v-if="!isUpdatingPluzz">
              <i class="fa fa-check me-2"></i>{{ $t("update_btn") }}
            </template>
            <template v-else>
              <img
                width="20"
                class="inline"
                src="@/assets/img/gif/load2.gif"
                alt="loader"
              />
              <span class="ms-2">{{ $t("updating_in_progress") }}</span>
            </template>
          </button>
        </div>
      </template>
    </scalable-modal>

    <!-- SSO Domain Modal -->
    <scalable-modal
      @close="showSSODomainModal = false"
      @callback="confirmAddSSODomain"
      :open="showSSODomainModal"
      :advancedControl="true"
      :validationButtonText="$t('modal_add')"
      :exitButtonText="$t('btn_cancel')"
      displayMode="flex"
      :style="'width: 30em;'"
      :uid="'sso-domain-modal'"
    >
      <template v-slot:title>
        <h5 style="color: #132b4d">{{ $t("add_sso_domain") }}</h5>
      </template>
      <template v-slot:content>
        <div class="p-3">
          <p class="mb-3">
            {{ $t("choose_domain_message") }}
            l'authentification SSO.
          </p>
          <div class="form-group">
            <label class="block mb-2"><strong>Domaine</strong></label>
            <input
              type="text"
              v-model="newDomain"
              class="form-control"
              placeholder="exemple.com"
            />
          </div>
        </div>
      </template>
    </scalable-modal> 

    <!-- LDAP Configuration Modal -->
    <scalable-modal
      @close="showLDAPModal = false"
      @callback="saveLDAPConfiguration"
      :open="showLDAPModal"
      :advancedControl="true"
      :validationButtonText="$t('save')"
      :exitButtonText="$t('btn_cancel')"
      displayMode="flex"
      :style="'width: 40em; max-height: 90vh; overflow-y: auto;'"
      :uid="'ldap-config-modal'"
    >
      <template v-slot:title>
        <h5 style="color: #132b4d">Configuration LDAP</h5>
      </template>
      <template v-slot:content>
        <div class="p-3">
          <p class="mb-3">
            {{ $t("ldap_configuration_message") }}
            organisation.
          </p>

          <div class="form-group mb-3">
            <label class="block mb-2"
              ><strong>URI du serveur LDAP</strong>
              <span class="text-danger">*</span></label
            >
            <input
              type="text"
              v-model="ldapConfig.ldap_server_uri"
              class="form-control"
              placeholder="ldap://example.com:389"
              required
            />
          </div>

          <div class="form-group mb-3">
            <label class="block mb-2"
              ><strong>DN de liaison (Bind DN)</strong>
              <span class="text-danger">*</span></label
            >
            <input
              type="text"
              v-model="ldapConfig.ldap_bind_dn"
              class="form-control"
              placeholder="cn=admin,dc=example,dc=com"
              required
            />
          </div>

          <div class="form-group mb-3">
            <label class="block mb-2"
              ><strong>Mot de passe de liaison</strong>
              <span class="text-danger">*</span></label
            >
            <input
              type="password"
              v-model="ldapConfig.ldap_bind_password"
              class="form-control"
              placeholder="••••••••"
              required
            />
          </div>

          <div class="form-group mb-3">
            <label class="block mb-2"
              ><strong>Base de recherche utilisateur</strong>
              <span class="text-danger">*</span></label
            >
            <input
              type="text"
              v-model="ldapConfig.ldap_user_search_base"
              class="form-control"
              placeholder="ou=users,dc=example,dc=com"
              required
            />
          </div>

          <div class="form-group mb-3">
            <label class="block mb-2"
              ><strong>Filtre de recherche utilisateur</strong>
              <span class="text-danger">*</span></label
            >
            <input
              type="text"
              v-model="ldapConfig.ldap_user_search_filter"
              class="form-control"
              placeholder="(uid=%(user)s)"
              required
            />
            <small class="text-muted"
              >Utilisez %(user)s comme placeholder pour le nom
              d'utilisateur</small
            >
          </div>

          <div class="form-group mb-3">
            <div class="d-flex align-items-center">
              <label class="form-check-label me-3">
                <input
                  type="checkbox"
                  v-model="ldapConfig.use_ssl"
                  class="form-check-input me-2"
                />
                <strong>Utiliser SSL</strong>
              </label>
            </div>
          </div>

          <div class="form-group mb-3">
            <div class="d-flex align-items-center">
              <label class="form-check-label me-3">
                <input
                  type="checkbox"
                  v-model="ldapConfig.use_tls"
                  class="form-check-input me-2"
                />
                <strong>Utiliser TLS</strong>
              </label>
            </div>
          </div>
        </div>
      </template>
    </scalable-modal>
    <!-- Edit Domain Modal -->
    <scalable-modal
      @callback="updateEmailDomain"
      :break="exitEditDomainModal"
      :uid="'edit-domain-modal'"
      @close="editDomainModal = false"
      :open="editDomainModal"
      :advancedControl="true"
      :validationButtonText="$t('modal_update')"
      :exitButtonText="$t('modal_no')"
      displayMode="flex"
      :style="'width: 35em; height: 20em;'"
    >
      <template v-slot:content>
        <div class="col-12 pl-0">
          <div class="form-group py-3 pe-0 pe-md-2">
            <label class="mb-2">
              <strong>Modifier le domaine d'e-mail</strong>
            </label>
            <input
              type="text"
              v-model="editingDomain.domain"
              class="form-control"
              placeholder="exemple.com"
            />
          </div>
        </div>
      </template>
    </scalable-modal>
    <!-- Delete Domain Confirmation Modal -->
    <scalable-modal
      @callback="confirmDeleteDomain"
      :break="exitDeleteDomainModal"
      :uid="'delete-domain-modal'"
      @close="deleteDomainModal = false"
      :open="deleteDomainModal"
      :advancedControl="true"
      :validationButtonText="$t('modal_yes')"
      :exitButtonText="$t('modal_no')"
      displayMode="flex"
      :style="'width: 30em; height: 18em;'"
    >
      <template v-slot:content>
        <div class="col-12 pl-0">
          <div class="form-group py-3 pe-0 pe-md-2">
            <p class="mb-2">
              <strong>Êtes-vous sûr de vouloir supprimer ce domaine ?</strong>
            </p>
            <p class="text-muted">
              Domaine: <strong>{{ deletingDomain.domain }}</strong>
            </p>
            <p class="text-danger small">
              Cette action est irréversible.
            </p>
          </div>
        </div>
      </template>
    </scalable-modal>

    <!-- Module Reminder Template Modal -->
    <scalable-modal
      @close="showReminderTemplateModal = false"
      @callback="saveReminderTemplate"
      :open="showReminderTemplateModal"
      :advancedControl="true"
      :validationButtonText="$t('module_reminder.save_template')"
      :exitButtonText="$t('btn_cancel')"
      displayMode="flex"
      :style="'width: 50em; max-height: 90vh; overflow-y: auto;'"
      :uid="'reminder-template-modal'"
      :waitingAPI="savingReminderTemplate"
    >
      <template v-slot:title>
        <h5 style="color: #132b4d">{{ $t("module_reminder.custom_template_title") }}</h5>
      </template>
      <template v-slot:content>
        <div class="p-3 w-100">
          <div class="mb-4 p-3" style="background-color: #f8f9fa; border-radius: 0.5em;">
            <h6 class="mb-3">{{ $t("module_reminder.placeholders_title") }}</h6>
            <div class="row">
              <div class="col-6 mb-2" v-for="(variable, index) in availableVariables" :key="index">
                <code style="cursor: pointer;" class="text-primary" @click="insertVariable(variable.code)" title="Cliquer pour insérer">{{ variable.code }}</code> - {{ $t(variable.label) }}
              </div>
            </div>
          </div>

          <!-- Template editor -->
          <div class="form-group">
            <label class="mb-2"><strong>{{ $t("module_reminder.custom_template_title") }}</strong></label>
            <textarea
              ref="reminderTemplateInput"
              v-model="customReminderTemplate"
              class="form-control w-100"
              style="height: 150px;"
              rows="12"
              :placeholder="defaultReminderTemplate"
            ></textarea>
            <small v-if="reminderTemplateValidationError" class="text-danger">
              {{ $t("module_reminder.validation_error") }}
            </small>
          </div>

          <!-- Preview -->
          <div class="mt-4">
            <h6 class="mb-2">{{ $t("module_reminder.preview_title") }}</h6>
            <div class="p-3 border rounded bg-white" v-html="previewReminderTemplate"></div>
          </div>
        </div>
      </template>
    </scalable-modal>

    <!-- MS Teams Configuration Modal -->
    <scalable-modal
      :uid="'teams-config-modal'"
      @close="showTeamsModal = false"
      :open="showTeamsModal"
      :title="$t('ms_teams_credentials')"
      :advancedControl="true"
      :validationButtonText="teamsCredentials.id ? $t('ms_teams_update') : $t('ms_teams_save')"
      :exitButtonText="$t('common.cancel')"
      @callback="saveTeamsCredentials"
      :isWorking="savingTeams"
      :disableValidation="!teamsCredentials.client_id || !teamsCredentials.client_secret || !teamsCredentials.tenant_id || !teamsCredentials.sender_user_id"
      displayMode="flex"
      :style="'width: 50em; height: 42em;'"
    >
      <template v-slot:content>
        <div class="row w-100 px-3">
          <div class="col-12 d-flex justify-content-between align-items-center mb-4">
            <h5 class="mb-0">{{ $t("ms_teams_configure") }}</h5>
            <div v-if="teamsCredentials.id">
              <button class="btn btn-sm btn-outline-danger" @click="showTeamsDeleteModal = true">
                <i class="fa fa-trash me-1"></i> {{ $t("ms_teams_delete") }}
              </button>
            </div>
          </div>

          <!-- Client ID -->
          <div class="col-12 mb-3">
            <div class="form-group">
              <label class="f-14 f-w-500 mb-2">{{ $t("ms_teams_client_id") }}</label>
              <div class="input-group">
                <input
                  :type="showTeamsCredentials.client_id ? 'text' : 'password'"
                  class="form-control"
                  v-model="teamsCredentials.client_id"
                  placeholder="Enter Client ID"
                />
                <button class="btn btn-outline-secondary" type="button" @click="showTeamsCredentials.client_id = !showTeamsCredentials.client_id">
                  <i class="fa" :class="showTeamsCredentials.client_id ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Client Secret -->
          <div class="col-12 mb-3">
            <div class="form-group">
              <label class="f-14 f-w-500 mb-2">{{ $t("ms_teams_client_secret") }}</label>
              <div class="input-group">
                <input
                  :type="showTeamsCredentials.client_secret ? 'text' : 'password'"
                  class="form-control"
                  v-model="teamsCredentials.client_secret"
                  placeholder="Enter Client Secret"
                />
                <button class="btn btn-outline-secondary" type="button" @click="showTeamsCredentials.client_secret = !showTeamsCredentials.client_secret">
                  <i class="fa" :class="showTeamsCredentials.client_secret ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Tenant ID -->
          <div class="col-12 mb-3">
            <div class="form-group">
              <label class="f-14 f-w-500 mb-2">{{ $t("ms_teams_tenant_id") }}</label>
              <div class="input-group">
                <input
                  :type="showTeamsCredentials.tenant_id ? 'text' : 'password'"
                  class="form-control"
                  v-model="teamsCredentials.tenant_id"
                  placeholder="Enter Tenant ID"
                />
                <button class="btn btn-outline-secondary" type="button" @click="showTeamsCredentials.tenant_id = !showTeamsCredentials.tenant_id">
                  <i class="fa" :class="showTeamsCredentials.tenant_id ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Sender User ID -->
          <div class="col-12 mb-3">
            <div class="form-group">
              <label class="f-14 f-w-500 mb-2">{{ $t("ms_teams_sender_user_id") }}</label>
              <div class="input-group">
                <input
                  :type="showTeamsCredentials.sender_user_id ? 'text' : 'password'"
                  class="form-control"
                  v-model="teamsCredentials.sender_user_id"
                  placeholder="Enter Sender User ID"
                />
                <button class="btn btn-outline-secondary" type="button" @click="showTeamsCredentials.sender_user_id = !showTeamsCredentials.sender_user_id">
                  <i class="fa" :class="showTeamsCredentials.sender_user_id ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </scalable-modal>

    <!-- MS Teams Delete Confirmation Modal -->
    <scalable-modal
      @callback="deleteTeamsCredentials"
      :break="null"
      :uid="'teams-delete-modal'"
      @close="showTeamsDeleteModal = false"
      :open="showTeamsDeleteModal"
      :advancedControl="true"
      :validationButtonText="$t('modal_yes')"
      :exitButtonText="$t('modal_no')"
      displayMode="flex"
      :style="'width: 30em; height: 22em;'"
    >
      <template v-slot:content>
        <div class="col-12 pl-0">
          <div class="form-group py-3 pe-0 pe-md-2 text-center">
            <i class="fa fa-exclamation-triangle fa-3x text-warning mb-3"></i>
            <p class="mb-2">
              <strong>{{ $t("ms_teams_delete_confirm") }}</strong>
            </p>
          </div>
        </div>
      </template>
    </scalable-modal>
  </div>
</template>

<script>
import CFAFooter from "@/components/nav/CFAFooter.vue";
import CFANav from "@/components/nav/CFANav.vue";
import { getAPI } from "@/axios-api";
import VueDatePicker from "@vuepic/vue-datepicker";
import AppTheme from "@/components/shared/AppTheme.vue";
//import countryCode from '@/components/shared/input/countryCode.vue';
import InputPhone from "@/components/shared/input/InputPhone.vue";
import ScalableModal from "@/components/shared/modal/ScalableModal.vue";
import utils from "@/composable/utils";
import country from "@/components/shared/input/country.vue";
import { ref } from "vue";

export default {
  name: "CompanyView",
  components: {
    VueDatePicker,
    CFAFooter,
    CFANav,
    AppTheme,
    //countryCode,
    InputPhone,
    ScalableModal,
    country,
  },

  setup() {
    const pluzzModules = ref([]);

    return {
      pluzzModules,
    };
  },

  data() {
    return {
      waitingAPIResponse: true,
      orgData: null,
      activityData: null,
      activityOptions: [],
      modulesData: [],
      modules: [],
      orgDataLogo: null,
      orgDataFavicon: null,
      alertString: "",
      isOrg: true,
      uploadPending: false,
      faviconUploadPending: false,
      subscriptionData: [],
      silentRefresh: null,
      updateLoading1: false,
      updateLoading2: false,
      updateLoading3: false,
      resetLoading: false,
      selectedModules: [],
      dateEnd: null,
      lastTransactionPlan: "",
      remain_days: "",
      expiration_date: "",
      phone: "",
      codeConfirmBox: false,
      exitCodeModal: null,
      resetConfirmBox: false,
      updatePluzzTargetBox: false,
      exitResetModal: null,
      exitPluzzTargetModal: null,
      maxWords: 300,
      manager_notice: null,
      custom_message: "",
      isSetCustomMessage: null,
      // Spectorly Pluzz data
      pluzzActivated: false,
      services: [],
      groupes: [],
      showTargetModal: false,
      currentModule: null,
      // pluzzModules: [
      //   {
      //     id: 'pluzz1',
      //     name: 'MODULE PLUZZ 1 - Sécurité Avancée',
      //     activated: false,
      //     targetSelected: null,
      //     targets: [
      //       { id: 'group1', name: 'Groupe Marketing' },
      //       { id: 'group2', name: 'Groupe Développement' },
      //       { id: 'group3', name: 'Groupe Direction' },
      //       { id: 'service1', name: 'Service Client' },
      //       { id: 'service2', name: 'Service Technique' }
      //     ]
      //   },
      //   {
      //     id: 'pluzz2',
      //     name: 'MODULE PLUZZ 2 - Protection des Données',
      //     activated: false,
      //     targetSelected: null,
      //     targets: [
      //       { id: 'group1', name: 'Groupe Marketing' },
      //       { id: 'group2', name: 'Groupe Développement' },
      //       { id: 'group3', name: 'Groupe Direction' },
      //       { id: 'service1', name: 'Service Client' },
      //       { id: 'service2', name: 'Service Technique' }
      //     ]
      //   },
      //   {
      //     id: 'pluzz3',
      //     name: 'MODULE PLUZZ 3 - Conformité RGPD',
      //     activated: false,
      //     targetSelected: null,
      //     targets: [
      //       { id: 'group1', name: 'Groupe Marketing' },
      //       { id: 'group2', name: 'Groupe Développement' },
      //       { id: 'group3', name: 'Groupe Direction' },
      //       { id: 'service1', name: 'Service Client' },
      //       { id: 'service2', name: 'Service Technique' }
      //     ]
      //   }
      // ],
      // SSO config
      selectedProvider: null,
      savingSSO: false,
      ssoEnabled: false,
      hasSSOConfiguration: false,
      showSSODomainModal: false,
      newDomain: "",
      domains: [],
      availableEmailDomains: [],
      ssoToggleLoading: false,
      ssoConfigurationId: null,
      selectedDomainToAdd: null,
      editDomainModal: false,
      deleteDomainModal: false,
      exitEditDomainModal: null,
      exitDeleteDomainModal: null,
      editingDomain: { id: null, domain: "" },
      deletingDomain: { id: null, domain: "" },
      // LDAP/SSO config
      showLDAPModal: false,
      ldapConfig: {
        ldap_server_uri: "",
        ldap_bind_dn: "",
        ldap_bind_password: "",
        ldap_user_search_base: "",
        ldap_user_search_filter: "",
        use_ssl: false,
        use_tls: false,
      },
      savingLDAP: false,
      providerOptions: [
        { value: "google", label: "Google Workspace" },
        { value: "microsoft", label: "Microsoft Entra ID" },
        { value: "ldap", label: "LDAP" },
      ],
      activePluzzTab: "groups",
      isAllAccesType: false,
      moduleToUpdateAll: false,
      isUpdatingPluzz: false,
      selectedPluzz: {
        groups: [],
        services: [],
      },
      currentPage: 1,
      pageSize: 5,
      currentPageGroups: 1,
      currentPageServices: 1,
      // Module Reminder Template
      isCustomReminderEnabled: false,
      customReminderTemplate: '',
      showReminderTemplateModal: false,
      savingReminderTemplate: false,
      reminderTemplateValidationError: false,
      defaultReminderTemplate: '<p>Bonjour {{user.firstname}},</p><p>Nous vous rappelons que vous avez jusqu\'au <strong>{{end_date}}</strong> pour compléter le module <strong>{{module_title}}</strong>.</p><p>Votre progression actuelle: {{progression}}%</p><p><a href="{{url_frontend}}">Accéder à la plateforme</a></p>',
      availableVariables: [
        { code: '{{user.firstname}}', label: 'module_reminder.placeholder_firstname' },
        { code: '{{user.lastname}}', label: 'module_reminder.placeholder_lastname' },
        { code: '{{end_date}}', label: 'module_reminder.placeholder_end_date' },
        { code: '{{url_frontend}}', label: 'module_reminder.placeholder_url' },
        { code: '{{module_title}}', label: 'module_reminder.placeholder_module_title' },
        { code: '{{progression}}', label: 'module_reminder.placeholder_progression' },
      ],
      // MS Teams credentials
      teamsCredentials: {
        id: null,
        client_id: "",
        client_secret: "",
        tenant_id: "",
        sender_user_id: "",
      },
      showTeamsCredentials: {
        client_id: false,
        client_secret: false,
        tenant_id: false,
        sender_user_id: false,
      },
      loadingTeams: false,
      savingTeams: false,
      showTeamsDeleteModal: false,
      showTeamsModal: false,
    };
  },
  computed: {
    totalGroupsPages() {
      return Math.ceil(this.groupes.length / this.pageSize);
    },
    totalServicesPages() {
      return Math.ceil(this.services.length / this.pageSize);
    },
    paginatedGroups() {
      let start = (this.currentPageGroups - 1) * this.pageSize;
      return this.groupes.slice(start, start + this.pageSize);
    },
    paginatedServices() {
      let start = (this.currentPageServices - 1) * this.pageSize;
      return this.services.slice(start, start + this.pageSize);
    },
    currentWordCount() {
      return this.custom_message
        .trim()
        .split(/\s+/)
        .filter((word) => word).length;
    },
    isManager() {
      const role = (localStorage.getItem("role") || "").toLowerCase();
      return role === "manager" || role === "admin" || role === "organisation";
    },
    // SSO computed properties
    canShowSSOToggle() {
      const flag =
        this.orgData?.sso_enabled || this.orgData?.sso_configuration_enabled;
      if (typeof flag === "boolean") return flag;
      return this.ssoEnabled || !!this.selectedProvider;
    },
    showSSOToggleButton() {
      // Only show the toggle button when SSO is enabled for the organization
      return this.ssoEnabled === true;
    },
    // Module Reminder computed
    previewReminderTemplate() {
      const template = this.customReminderTemplate || this.defaultReminderTemplate;
      return template
        .replace(/\{\{user\.firstname\}\}/g, 'Jean')
        .replace(/\{\{user\.lastname\}\}/g, 'Dupont')
        .replace(/\{\{end_date\}\}/g, '31 Décembre 2025')
        .replace(/\{\{url_frontend\}\}/g, window.location.origin)
        .replace(/\{\{module_title\}\}/g, 'Cybersécurité Niveau 1')
        .replace(/\{\{progression\}\}/g, '45');
    },
  },
  methods: {
    prevPage(tab) {
      if (tab === "groups") {
        if (this.currentPageGroups > 1) this.currentPageGroups--;
      } else if (tab === "services") {
        if (this.currentPageServices > 1) this.currentPageServices--;
      }
    },
    nextPage(tab) {
      if (tab === "groups") {
        if (this.currentPageGroups < this.totalGroupsPages)
          this.currentPageGroups++;
      } else if (tab === "services") {
        if (this.currentPageServices < this.totalServicesPages)
          this.currentPageServices++;
      }
    },

    // Module Reminder Methods
    async getCustomReminderTemplate() {
      try {
        const orgId = localStorage.getItem('organisation');
        const response = await getAPI.get(`organisations/${orgId}/custom_module_reminder_template/`);
        if (response.data?.success && response.data?.data?.custom_module_reminder_template) {
          this.customReminderTemplate = response.data.data.custom_module_reminder_template;
          this.isCustomReminderEnabled = true;
        } else {
          this.isCustomReminderEnabled = false;
        }
      } catch (error) {
        console.log('Using default template');
        this.isCustomReminderEnabled = false;
      }
    },

    toggleCustomReminder() {
      if (this.isCustomReminderEnabled) {
        // Disable and remove custom template
        this.removeCustomReminderTemplate();
      } else {
        // Open modal to create template
        this.showReminderTemplateModal = true;
      }
    },

    openReminderTemplateModal() {
      this.reminderTemplateValidationError = false;
      this.showReminderTemplateModal = true;
    },

    insertVariable(variable) {
      const textarea = this.$refs.reminderTemplateInput;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = this.customReminderTemplate || '';

      const before = text.substring(0, start);
      const after = text.substring(end);

      this.customReminderTemplate = before + variable + after;

      this.$nextTick(() => {
        textarea.focus();
        textarea.selectionStart = textarea.selectionEnd = start + variable.length;
      });
    },

    validateReminderTemplate() {
      // Check if template contains at least one variable
      const variables = [
        '{{user.firstname}}',
        '{{user.lastname}}',
        '{{end_date}}',
        '{{url_frontend}}',
        '{{module_title}}',
        '{{progression}}'
      ];
      const template = this.customReminderTemplate || '';
      const hasVariable = variables.some(v => template.includes(v));
      this.reminderTemplateValidationError = !hasVariable;
      return hasVariable;
    },

    async saveReminderTemplate() {
      if (!this.validateReminderTemplate()) {
        return;
      }

      this.savingReminderTemplate = true;
      try {
        const orgId = localStorage.getItem('organisation');
        const response = await getAPI.put(`organisations/${orgId}/custom_module_reminder_template/`, {
          custom_module_reminder_template: this.customReminderTemplate
        });
        if (response.data?.success) {
          this.isCustomReminderEnabled = true;
          this.showReminderTemplateModal = false;
          this.alertString = `${this.$t('module_reminder.template_saved_success')}|alert-yes|5000::${Date.now()}`;
        }
      } catch (error) {
        console.error('Error saving reminder template:', error);
        this.alertString = `${this.$t('module_reminder.template_save_error')}|alert-no|5000::${Date.now()}`;
      } finally {
        this.savingReminderTemplate = false;
      }
    },

    async removeCustomReminderTemplate() {
      try {
        const orgId = localStorage.getItem('organisation');
        await getAPI.put(`organisations/${orgId}/custom_module_reminder_template/`, {
          custom_module_reminder_template: null
        });
        this.isCustomReminderEnabled = false;
        this.customReminderTemplate = '';
        this.alertString = `${this.$t('module_reminder.default_template_active')}|alert-yes|5000::${Date.now()}`;
      } catch (error) {
        console.error('Error removing template:', error);
      }
    },

    hexToRgb(hex) {
      hex = hex.replace("#", "");

      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return { r, g, b };
    },
    retrieveOrg() {
      getAPI
        .get(`organisations/${localStorage.organisation}/`)
        .then((response) => {
          if (response.status == 200) {
            this.organisationData = response.data;
            this.primary = this.organisationData.primary_color;
            this.secondary = this.organisationData.secondary_color;
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle server response error
            console.error("Server error:", error.response.data);
            this.alertString = `${
              error.response.data.message || "Server error occurred"
            }|alert-no|5000::${Date.now()}`;
          } else if (error.request) {
            // Handle network/request error
            console.error("Network error - no response received");
            this.alertString = `Network error - please check your connection|alert-no|8000::${Date.now()}`;
          } else {
            // Handle other errors
            console.error("Error:", error.message);
            this.alertString = `An unexpected error occurred|alert-no|5000::${Date.now()}`;
          }
        });
    },
    saveColor() {
      const payload = {
        primary_color: this.primary_color,
        secondary_color: this.secondary_color,
        tertiary_color: this.tertiary_color,
      };
      getAPI
        .put(
          `organisations/change_color/${localStorage.organisation}/`,
          payload
        )
        .then((response) => {
          if (response.status === 200) {
            console.log("response", response);
            if (response.data.data) {
              localStorage.setItem(
                "tertiaryColor",
                response.data.data.tertiary_color
              );
            }
            this.alertString =
              "Couleur changée avec succès |alert-yes|5000::" + Date.now();
          } else {
            this.alertString =
              "Oups ! something went wrong.|alert-no|5000::" + Date.now();
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log("respose", error.response);
            this.alertString =
              `Changer de formule pour obtenir cette fonctionnalité|alert-no|5000::` +
              Date.now();
          } else if (error.request) {
            this.alertString =
              "The request was made but no response was received. Please check your network.|alert-no|8000::" +
              Date.now();
          } else {
            this.alertString =
              "Oups ! something went wrong.|alert-no|5000::" + Date.now();
          }
        });
    },
    activeColor() {
      const primaryColor = this.primary;
      if (primaryColor) {
        const primaryRgb = this.hexToRgb(primaryColor);
        const pr = primaryRgb.r;
        const pg = primaryRgb.g;
        const pb = primaryRgb.b;
        document.documentElement.style.setProperty(
          "--primary-color",
          primaryColor
        );
        document.documentElement.style.setProperty("--primary-color-r", pr);
        document.documentElement.style.setProperty("--primary-color-g", pg);
        document.documentElement.style.setProperty("--primary-color-b", pb);
      }

      //secondary
      const secondaryColor = this.secondary;
      if (secondaryColor) {
        const secondaryRgb = this.hexToRgb(secondaryColor);
        const sr = secondaryRgb.r;
        const sg = secondaryRgb.g;
        const sb = secondaryRgb.b;
        document.documentElement.style.setProperty(
          "--secondary-color",
          secondaryColor
        );
        document.documentElement.style.setProperty("--secondary-color-r", sr);
        document.documentElement.style.setProperty("--secondary-color-g", sg);
        document.documentElement.style.setProperty("--secondary-color-b", sb);
      }
    },
    async setPrimaryColor() {
      this.primary_color = this.primary;
      this.saveColor();
      const actualColor = this.primary;
      const rgb = this.hexToRgb(this.primary);
      // Update separate RGB values
      const r = rgb.r;
      const g = rgb.g;
      const b = rgb.b;
      document.documentElement.style.setProperty(
        "--primary-color",
        actualColor
      );
      document.documentElement.style.setProperty("--primary-color-r", r);
      document.documentElement.style.setProperty("--primary-color-g", g);
      document.documentElement.style.setProperty("--primary-color-b", b);
    },
    async setSecondaryColor() {
      this.secondary_color = this.secondary;
      this.saveColor();
      const rgb = this.hexToRgb(this.secondary);
      // Update separate RGB values
      const r = rgb.r;
      const g = rgb.g;
      const b = rgb.b;
      document.documentElement.style.setProperty(
        "--secondary-color",
        this.secondary
      );
      document.documentElement.style.setProperty("--secondary-color-r", r);
      document.documentElement.style.setProperty("--secondary-color-g", g);
      document.documentElement.style.setProperty("--secondary-color-b", b);
    },
    updateCode() {
      this.waitingAPIResponse = true;
      getAPI
        .patch(`organisations/${localStorage.organisation}/`, {
          code: "",
        })
        .then((response) => {
          //let msg = 'Code changé avec succès'
          //this.alertString = `${msg}|alert-yes|5000::`+Date.now()
          console.log(response);
          setTimeout(() => {
            this.waitingAPIResponse = false;
          }, 2000);
          this.orgData.code = response.data.code;
          this.exitCodeModal = Date.now();
        })
        .catch((error) => {
          if (error.response) {
            //this.alertString = `${error.response.data.message}|alert-no|10000::`+Date.now()
          } else if (error.request) {
            //let msg = 'The request was made but no response was received. Please check your network.'
            //this.alertString = `${msg}|alert-no|8000::`+Date.now()
          } else {
            // //let msg = 'Oups ! something went wrong.'
            ////this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          this.waitingAPIResponse = false;
        });
    },
    canSetDate() {
      return (
        this.subscriptionData?.length != 0 &&
        localStorage.type_account == "organisation"
      );
    },
    getModule() {
      this.waitingAPIResponse = true;
      getAPI
        .get("modules/all")
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            console.log("dataModule:", response.data.data);
            this.modulesData = response.data.data;
            // this.pluzzModules = response.data.data
            let org = localStorage.getItem("organisation");
            // Flatten and assign data to modules list
            this.modules = this.modulesData.map((module) => {
              const isVisible = module.is_visible_for.some(
                (uuid) => uuid === org
              );
              return {
                id: module.id,
                name: "MODULE " + module.number + " - " + module.title,
                is_visible_for: module.is_visible_for,
                visible: isVisible,
              };
            });

            console.log("Modules: ", this.modules);
          } else {
            // //let msg = 'Oups ! something went wrong.'
            ////this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          setTimeout(() => {
            this.waitingAPIResponse = false;
          }, 2000);
        })
        .catch((error) => {
          if (error.response) {
            //this.alertString = `${error.response.data.message}|alert-no|10000::`+Date.now()
          } else if (error.request) {
            //let msg = 'The request was made but no response was received. Please check your network.'
            //this.alertString = `${msg}|alert-no|8000::`+Date.now()
          } else {
            ////let msg = 'Oups ! something went wrong.'
            ////this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          this.waitingAPIResponse = false;
        });
    },
    toggleVisibility(module) {
      module.visible = !module.visible;
    },
    updateVisibilities(module, index = 0) {
      console.log(module);
      //this.waitingAPIResponse = true
      if (module.visible == true) {
        //console.log(module);
        getAPI
          .patch(`modules/make_module_visible/${module.id}?is_visible=false`)
          .then((response) => {
            if (response.status == 200) {
              console.log("response", response);
              this.alertString =
                `Le module ${index + 1} n'est plus visible|alert-yes|5000::` +
                Date.now();
            } else {
              this.alertString =
                "Une erreur s'est produite |alert-no|5000::" + Date.now();
            }
            this.getModule();
            setTimeout(() => {
              //this.waitingAPIResponse = false
            }, 2000);
          })
          .catch(() => {
            this.alertString = "Une erreur.|alert-no|5000::" + Date.now();
          });
      } else {
        getAPI
          .patch(`modules/make_module_visible/${module.id}?is_visible=true`)
          .then((response) => {
            if (response.status == 200) {
              console.log("response", response);
              this.alertString =
                `Le module ${index + 1} est visible|alert-yes|5000::` +
                Date.now();
            } else {
              this.alertString =
                `Quelque chose s'est mal passé.|alert-no|5000::` + Date.now();
            }
            this.getModule();
            setTimeout(() => {
              this.waitingAPIResponse = false;
            }, 2000);
          })
          .catch(() => {
            this.alertString =
              "Quelque chose s'est mal passé.|alert-no|5000::" + Date.now();
          });
      }
    },

    updateVisibility(modules) {
      console.log("test", modules);

      // Function to send API request
      const sendVisibilityUpdate = (moduleIds, isVisible) => {
        if (moduleIds.length === 0) return;

        getAPI
          .patch(`modules/make_visible`, {
            modules_ids: moduleIds,
            is_visible: isVisible,
          })
          .then((response) => {
            if (response.status === 200) {
              console.log("response", response);
              this.alertString =
                `Les modules sont maintenant ${
                  isVisible === "false" ? "invisibles" : "visibles"
                } |alert-yes|5000::` + Date.now();
            } else {
              this.alertString =
                "Une erreur s'est produite |alert-no|5000::" + Date.now();
            }
            this.getModule();
          })
          .catch(() => {
            this.alertString = "Une erreur.|alert-no|5000::" + Date.now();
          });
      };

      // Send API requests for both visible and invisible module updates
      //sendVisibilityUpdate(invisibleModules, "false");
      //sendVisibilityUpdate(visibleModules, "true");
      if (modules.every((module) => module.visible)) {
        sendVisibilityUpdate(
          modules.map((module) => module.id),
          "false"
        );
      } else {
        sendVisibilityUpdate(
          modules.map((module) => module.id),
          "true"
        );
      }
    },

    // SSO configuration loading
    async loadSSOConfiguration() {
      try {
        const orgId = localStorage.getItem("organisation");
        if (!orgId) return;
    
        const response = await getAPI.get("sso/sso-configurations/");
        if (response.status === 200 && response.data) {
          // Find SSO configuration for current organisation
          const ssoConfigs = Array.isArray(response.data)
            ? response.data
            : response.data.results || [];
          const orgSSOConfig = ssoConfigs.find(
            (config) =>
              config.organisation === orgId || config.organisation?.id === orgId
          );
    
          if (orgSSOConfig) {
            this.ssoConfigurationId = orgSSOConfig.id;
            this.selectedProvider = orgSSOConfig.provider;
            console.log("Found SSO configuration for organisation:", {
              id: this.ssoConfigurationId,
              provider: this.selectedProvider,
            });
          }
        }
      } catch (error) {
        console.error("Error loading SSO configuration:", error);
      }
    },

    async getOrganisationData() {
      let org = localStorage.getItem("organisation");
      console.log("Organisation ID from localStorage:", org);
      if (org != null) {
        try {
          const response = await getAPI.get(`organisations/${org}/`);
          console.log("Organisation API response:", response);
          if (response.status == 200) {
            // La réponse peut être response.data directement OU response.data.data
            this.orgData = response.data;
            await this.fetchEmailDomains();
            this.domains = this.orgData?.access_domains || [];
            console.log("orgData assigned:", this.orgData);

            // Set SSO enabled status from organisation data
            this.ssoEnabled = this.orgData?.sso_enabled === true;
            this.hasSSOConfiguration =
              this.orgData?.has_sso_configuration === true;
            console.log("SSO enabled status:", this.ssoEnabled);
            console.log("Has SSO configuration:", this.hasSSOConfiguration);

            // Load SSO configuration if enabled or if configuration exists
            if (this.ssoEnabled || this.hasSSOConfiguration) {
              this.loadSSOConfiguration();
            }

            if (this.orgData.activity) {
              try {
                const res = await getAPI.get(`activity/${this.orgData.activity}/`);
                if (res.status == 200) {
                  this.activityData = res.data;
                  console.log("activity data", this.activityData);
                }
                this.waitingAPIResponse = false;
              } catch (error) {
                console.log("Activity API error:", error);
                if (error.response) {
                  this.alertString =
                    `Erreur lors du chargement de l'activité|alert-no|5000::` +
                    Date.now();
                } else if (error.request) {
                  let msg =
                    "The request was made but no response was received. Please check your network.";
                  this.alertString = `${msg}|alert-no|8000::` + Date.now();
                } else {
                  let msg = "Oups ! something went wrong.";
                  this.alertString = `${msg}|alert-no|5000::` + Date.now();
                }
                this.waitingAPIResponse = false;
              }
            } else {
              this.waitingAPIResponse = false;
            }
          }
        } catch (error) {
          console.log("Organisation API error:", error);
          if (error.response) {
            this.alertString =
              `Vous n'appartenez à aucune organisation|alert-no|10000::` +
              Date.now();
          } else if (error.request) {
            let msg =
              "The request was made but no response was received. Please check your network.";
            this.alertString = `${msg}|alert-no|8000::` + Date.now();
          } else {
            let msg = "Oups ! something went wrong.";
            this.alertString = `${msg}|alert-no|5000::` + Date.now();
          }
          this.waitingAPIResponse = false;
        }
      } else {
        this.isOrg = false;
        this.orgData = null;
        this.waitingAPIResponse = false;
      }
    },
    async getActivities() {
      try {
        const response = await getAPI.get("activity/");
        if (response.status === 200) {
          this.activityOptions = response.data.results;
        }
      } catch (error) {
        console.error("Error fetching activities:", error);
        this.alertString =
          "Erreur lors du chargement des secteurs d'activité|alert-no|5000::" +
          Date.now();
      }
    },
    getActivityOptions() {
      getAPI
        .get("activity/")
        .then((response) => {
          if (response.status === 200) {
            this.activityOptions = response.data.results || response.data;
            console.log("activity options", this.activityOptions);
          }
        })
        .catch((error) => {
          console.error("Error fetching activity options:", error);
        });
    },
    openFileSelector() {
      this.$refs.fileSelector.click();
    },
    openFaviconSelector() {
      this.$refs.faviconSelector.click();
    },
    async uploadImage() {
      const file = this.$refs.fileSelector.files[0];
      const formData = new FormData();
      //formData.append('logo', file);
      const maxSizeInMB = 2; // 2 MB
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
      if (file) {
        if (file.size > maxSizeInBytes) {
          console.log("File is within the size limit. Ready to upload.");
        } else {
          formData.append("logo", file);
        }
      }
      this.uploadPending = true;
      //return
      //eslint-disable-next-line
      getAPI
        .put(
          `organisations/upload_logo/${localStorage.organisation}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((payload) => {
          console.log(payload);
          this.orgDataLogo = payload.data.data.logo;
          location.reload();
          //this.alertString = "Profil mis à jour avec succès.|alert-yes|5000::"+Date.now()
          this.silentRefresh = Date.now();
          this.uploadPending = false;
        })
        .catch((err) => {
          //this.alertString = "Fichier trop large.|alert-no|5000::"+Date.now()
          this.uploadPending = false;
          console.log(err);
        });
    },
    async uploadFavicon() {
      const file = this.$refs.faviconSelector.files[0];
      const formData = new FormData();
      const maxSizeInMB = 1; // 1 MB for favicon
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

      if (file) {
        if (file.size > maxSizeInBytes) {
          this.alertString =
            "Le fichier favicon est trop volumineux (max 1MB)|alert-no|5000::" +
            Date.now();
          return;
        } else {
          formData.append("favicon", file);
        }
      }

      this.faviconUploadPending = true;

      try {
        const response = await getAPI.put(
          `organisations/upload_favicon/${localStorage.organisation}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log(response);
        this.orgDataFavicon = response.data.data.favicon;
        this.alertString =
          "Favicon mis à jour avec succès|alert-yes|5000::" + Date.now();
        this.silentRefresh = Date.now();
      } catch (error) {
        console.error("Favicon upload error:", error);
        this.alertString =
          "Erreur lors de l'upload du favicon|alert-no|5000::" + Date.now();
      } finally {
        this.faviconUploadPending = false;
      }
    },
    updateOrg(index) {
      this[`updateLoading${index}`] = true;

      if (this.orgData.phone.startsWith("+")) {
        this.orgData.phone = this.orgData.phone.slice(1);
      }

      const orgDataClone = { ...this.orgData };
      delete orgDataClone.logo;
      delete orgDataClone.favicon;
      utils.delObjectProps(orgDataClone);
      console.log("organisation data", orgDataClone);

      getAPI
        .patch(`organisations/${localStorage.organisation}/`, orgDataClone)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            console.log("response", response);
            this.alertString =
              "Informations mises à jour avec succès|alert-yes|5000::" +
              Date.now();
            this.getOrganisationData();
          } else {
            this.alertString =
              "Quelque chose s'est mal passé.|alert-no|5000::" + Date.now();
          }
        })
        .catch((error) => {
          console.error("Update error:", error);
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.alertString =
              `${error.response.data.message}|alert-no|5000::` + Date.now();
          } else {
            this.alertString =
              `${this.$t("fill_fields_properly")}|alert-no|5000::` +
              Date.now();
          }
        })
        .finally(() => {
          //this.updateLoading = false;
          this[`updateLoading${index}`] = false;
        });
    },
    retrieveUserTransactions() {
      this.waitingAPIResponse = true;
      getAPI
        .get(`/transactions/?user_id=${localStorage.getItem("user")}`)
        .then((response) => {
          if (response.status == 200) {
            this.transactionsData = response.data;

            this.transactions = [];

            const lastTransaction =
              this.transactionsData[this.transactionsData.length - 1];

            this.lastTransactionPlan = lastTransaction.plan.name;
          } else {
            ////let msg = 'Oups ! something went wrong.'
            ////this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          setTimeout(() => {
            this.waitingAPIResponse = false;
          }, 2000);
        })
        .catch((error) => {
          if (error.response) {
            //this.alertString = `${error.response.data.message}|alert-no|10000::`+Date.now()
          } else if (error.request) {
            //let msg = 'The request was made but no response was received. Please check your network.'
            //this.alertString = `${msg}|alert-no|8000::`+Date.now()
          } else {
            ////let msg = 'Oups ! something went wrong.'
            ////this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          this.waitingAPIResponse = false;
        });
    },
    retrieveUserSubscription() {
      this.waitingAPIResponse = true;
      getAPI
        .get(`subscriptions/find-subscription`)
        .then((response) => {
          if (response.status == 200) {
            this.subscriptionData = response.data.data;

            this.remain_days = this.subscriptionData.remain_days;

            const created_at = new Date(this.subscriptionData.created_at);
            created_at.setDate(created_at.getDate() + this.remain_days);

            const expirationDate = this.subscriptionData.next_payment_date;

            this.expiration_date = expirationDate;

            this.orgDataLogo = this.subscriptionData.organisation.logo;
            this.orgDataFavicon = this.subscriptionData.organisation.favicon;

            //console.log("Tatata: ", this.subscriptionData)
          } else {
            // //let msg = 'Oups ! something went wrong.'
            ////this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          setTimeout(() => {
            this.waitingAPIResponse = false;
          }, 2000);
        })
        .catch((error) => {
          if (error.response) {
            //this.alertString = `${error.response.data.message}|alert-no|10000::`+Date.now()
          } else if (error.request) {
            //let msg = 'The request was made but no response was received. Please check your network.'
            //this.alertString = `${msg}|alert-no|8000::`+Date.now()
          } else {
            // //let msg = 'Oups ! something went wrong.'
            ////this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          this.waitingAPIResponse = false;
        });
    },
    convertDate(dateString, dateOnly = false) {
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString();
      const formattedTime = date.toLocaleTimeString();
      if (!dateOnly) {
        return `<b>${formattedDate} à ${formattedTime}</b>`;
      }
      return `<b>${formattedDate}</b>`;
    },
    copyContent() {
      // Copy content of the div
      const divContent = this.$refs.myDiv.innerText;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(divContent);
      } else {
        const tempInput = document.createElement("input");
        tempInput.value = divContent;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      }

      // Show notification
      //this.alertString = "Code copié|alert-middle|3000::"+Date.now()
      this.$swal({
        title: "Code copié avec succès",
        html: "<p style='text-align: justify'>Vous pouvez partager ce code avec un utilisateur qui pourra s'inscrire avec ce dernier pour rejoindre votre organisation. Ses frais de sensibilisation seront ainsi pris en charge par votre organisation et vous pourrez faire le suivi de son évolution sur l'ensemble des modules disponibles.</p>",
        type: "warning",
        showCancelButton: false,
        confirmButtonText: "D'accord !",
      });
    },
    getDashboardData() {
      this.waitingAPIResponse = true;
      getAPI
        .get(`other/dashboard`)
        .then((response) => {
          if (response.status == 200) {
            this.dateEnd = response.data.data?.deadline;
          } else {
            // //let msg = 'Oups ! something went wrong.'
            ////this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          setTimeout(() => {
            this.waitingAPIResponse = false;
          }, 2000);
        })
        .catch((error) => {
          if (error.response) {
            //this.alertString = `${error.response.data.message}|alert-no|10000::`+Date.now()
          } else if (error.request) {
            //let msg = 'The request was made but no response was received. Please check your network.'
            //this.alertString = `${msg}|alert-no|8000::`+Date.now()
          } else {
            ////let msg = 'Oups ! something went wrong.'
            ////this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          this.waitingAPIResponse = false;
        });
    },
    enforceWordLimit() {
      const words = this.custom_message
        .trim()
        .split(/\s+/)
        .filter((word) => word);
      if (words.length > this.maxWords) {
        this.custom_message = words.slice(0, this.maxWords).join(" ");
      }
    },
    async getManagerNotice() {
      const response = await getAPI.get(`accounts/manager-notice/`);
      console.log(response);
      if (response?.data?.data && response.data.data !== null) {
        this.manager_notice = response.data.data[0];
        this.custom_message = this.manager_notice.text;
        this.isSetCustomMessage = this.manager_notice.is_active;
      }
    },
    updateCustomMessage() {
      if (this.manager_notice) {
        // Update existing notice
        getAPI
          .patch(`accounts/manager-notice/${this.manager_notice.id}/`, {
            text: this.custom_message,
          })
          .then((response) => {
            if (response.status === 200) {
              console.log("Manager notice updated successfully");
              this.alertString =
                `Message mis à jour avec succès |alert-yes|5000::` + Date.now();
            }
          })
          .catch((error) => {
            if (error.response) {
              console.error("Error updating notice:", error.response.data);
            } else if (error.request) {
              console.error("No response received:", error.request);
            } else {
              console.error("Error:", error.message);
            }
            this.alertString =
              `Un erreur s'est produite |alert-yes|5000::` + Date.now();
          });
      } else {
        // Create new notice
        getAPI
          .post("accounts/manager-notice/", {
            text: this.custom_message,
          })
          .then((response) => {
            if (response.status === 201) {
              console.log("Manager notice created successfully");
              this.manager_notice = response.data?.[0];
            }
          })
          .catch((error) => {
            if (error.response) {
              console.error("Error creating notice:", error.response.data);
            } else if (error.request) {
              console.error("No response received:", error.request);
            } else {
              console.error("Error:", error.message);
            }
          });
      }
    },
    async resetCustomization() {
      this.resetLoading = true;

      try {
        // Reset colors to default
        const defaultColors = {
          primary_color: "#0cbcc6", // Default primary color
          secondary_color: "#132c4e", // Default secondary color
          tertiary_color: "#28a745", // Default tertiary color
        };

        // Reset organization logo and colors
        const resetPayload = {
          logo: null,
          favicon: null,
          ...defaultColors,
        };

        const response = await getAPI.patch(
          `organisations/${localStorage.organisation}/`,
          resetPayload
        );

        if (response.status === 200) {
          // Reset CSS variables to default
          document.documentElement.style.setProperty(
            "--primary-color",
            defaultColors.primary_color
          );
          localStorage.setItem("primary_color", defaultColors.primary_color);
          document.documentElement.style.setProperty(
            "--secondary-color",
            defaultColors.secondary_color
          );
          localStorage.setItem(
            "secondary_color",
            defaultColors.secondary_color
          );
          document.documentElement.style.setProperty(
            "--tertiary-color",
            defaultColors.tertiary_color
          );

          // Update RGB values for primary color
          const primaryRgb = this.hexToRgb(defaultColors.primary_color);
          document.documentElement.style.setProperty(
            "--primary-color-r",
            primaryRgb.r
          );
          document.documentElement.style.setProperty(
            "--primary-color-g",
            primaryRgb.g
          );
          document.documentElement.style.setProperty(
            "--primary-color-b",
            primaryRgb.b
          );

          // Update RGB values for secondary color
          const secondaryRgb = this.hexToRgb(defaultColors.secondary_color);
          document.documentElement.style.setProperty(
            "--secondary-color-r",
            secondaryRgb.r
          );
          document.documentElement.style.setProperty(
            "--secondary-color-g",
            secondaryRgb.g
          );
          document.documentElement.style.setProperty(
            "--secondary-color-b",
            secondaryRgb.b
          );

          // Clear logo and favicon
          this.orgDataLogo = null;
          this.orgDataFavicon = null;

          this.alertString =
            "Personnalisation réinitialisée avec succès|alert-yes|5000::" +
            Date.now();

          // Refresh the page to apply all changes
          setTimeout(() => {
            location.reload();
          }, 1500);
        } else {
          this.alertString =
            "Erreur lors de la réinitialisation|alert-no|5000::" + Date.now();
        }
      } catch (error) {
        console.error("Reset error:", error);
        this.alertString =
          "Erreur lors de la réinitialisation|alert-no|5000::" + Date.now();
      } finally {
        this.resetLoading = false;
      }
    },
    updateShowMessage() {
      this.isSetCustomMessage = !this.isSetCustomMessage;
      console.log(this.isSetCustomMessage);
      getAPI
        .patch(`accounts/manager-notice/toggle/${this.manager_notice.id}/`, {
          is_active: this.isSetCustomMessage,
        })
        .then((response) => {
          if (response.status === 200) {
            console.log("Manager notice updated successfully");
            this.alertString =
              `Le message est maintenant ${
                this.isSetCustomMessage == false ? "invisible" : "visible"
              } aux utilisateurs |alert-yes|5000::` + Date.now();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getModulePluzz() {
      await getAPI
        .get(`module_pluzz/`)
        .then((response) => {
          if (response.status === 200) {
            console.log(response);
            this.pluzzModules = response.data.results.map((module) => {
              return {
                ...module,
                activated: module.statut === "available",
                selectedTargets:
                  module.access_type === "GROUP"
                    ? module.groups
                    : module.services,
                groups: module.groups.map((group) => group.id),
                services: module.services.map((service) => service.id),
              };
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching organization data:", error);
        });
    },

    togglePluzzActivation() {
      this.pluzzActivated = !this.pluzzActivated;
      this.pluzzModules.forEach(async (module) => {
        module.statut = this.pluzzActivated ? "available" : "unavailable";
        await this.togglePluzzModule(module, false);
      });

      // this.pluzzActivated = !this.pluzzActivated;
      // console.log(this.pluzzActivated)
      // if (this.pluzzActivated) {
      //   this.alertString = "Spectorly Pluzz activé|alert-yes|5000::" + Date.now();
      // } else {
      //   // Reset all module activations when Pluzz is deactivated
      //   this.pluzzModules.forEach(module => {
      //     module.activated = false;
      //     module.targetSelected = null;
      //   });
      //   this.alertString = "Spectorly Pluzz désactivé|alert-no|5000::" + Date.now();
      // }
    },

    async togglePluzzModule(visibility) {
      // module.activated = !module.activated;
      this.isUpdatingPluzz = true;
      await getAPI
        .patch(
          `module_pluzz/make_module_pluzz_visible/${this.selectedPluzz.id}?is_visible=${visibility}`,
          {
            access_type: "ALL",
          }
        )
        .then(async (response) => {
          console.log(response);
          this.updatePluzzTargetBox = false;
          await this.getModulePluzz();
          this.alertString =
            "Module activé avec succès pour tous les utilisateurs|alert-yes|5000::" +
            Date.now();
        })
        .catch((error) => {
          console.error("Error updating module pluzz targets:", error);
          this.alertString =
            "Erreur lors de l'activation du module pour tous les utilisateurs|alert-no|5000::" +
            Date.now();
        })
        .finally(() => {
          this.isUpdatingPluzz = false;
        });
    },

    openTargetModal(module) {
      this.currentModule = module;
      this.selectedPluzz = module;
      this.moduleToUpdateAll =
        module.access_type === "ALL" && module.statut === "available"
          ? true
          : false;
      console.log("Module to update all:", this.moduleToUpdateAll);
      //this.showTargetModal = true;
      this.updatePluzzTargetBox = true;
    },

    onTargetConfirm(selectedTargets) {
      if (this.currentModule) {
        this.currentModule.selectedTargets = selectedTargets;

        // Make API call to save the selections
        this.saveModuleTargets(this.currentModule.id, selectedTargets);

        const count = selectedTargets.length;
        this.alertString =
          `${count} ${this.$t("target_count")} pour ${this.currentModule.title}|alert-yes|5000::` +
          Date.now();
      }
    },

    getTargetButtonText(module) {
      const count = module.selectedTargets?.length || 0;
      if (count === 0) {
       const msg = this.$t("modules-pluzz-activation")
        return msg;
      }
      return `${count} ${this.$t("target_count")}`;
    },

    async saveModuleTargets(moduleId, targets) {
      try {
        // Adapt this API call according to your backend endpoint
        await getAPI.post(`module_pluzz/${moduleId}/assign_targets/`, {
          targets: targets,
        });
      } catch (error) {
        console.error("Error saving module targets:", error);
        this.alertString =
          `Erreur lors de la sauvegarde des cibles|alert-no|5000::` +
          Date.now();
      }
    },

    async getServices() {
      try {
        const response = await getAPI.get(
          `services/?organisation=${localStorage.organisation}`
        );
        if (response.status === 200) {
          this.services = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    },

    async getGroupes() {
      try {
        const response = await getAPI.get(`groupes/`);
        if (response.status === 200) {
          this.groupes = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    },

    updateReset() {
      this.resetCustomization();
    },
    // SSO configuration methods
    async persistSSOConfiguration() {
      const payload = {
        organisation: localStorage.getItem("organisation"),
        provider: this.selectedProvider,
        enabled: this.ssoEnabled,
        domains: this.domains,
      };
    
      const hasExistingConfig = !!this.ssoConfigurationId;
      const url = hasExistingConfig
        ? `sso/sso-configurations/${this.ssoConfigurationId}/`
        : "sso/sso-configurations/";
      const method = hasExistingConfig ? "put" : "post";
    
      const res = await getAPI[method](url, payload);
    
      if ([200, 201, 204].includes(res.status)) {
        const returnedId = res.data?.id || this.ssoConfigurationId;
        if (returnedId) {
          this.ssoConfigurationId = returnedId;
        }
        this.hasSSOConfiguration = true;
        return this.ssoConfigurationId;
      }
    
      throw new Error("Impossible d'enregistrer la configuration SSO");
    },

    async fetchEmailDomains() {
      try {
        const organisationId = localStorage.getItem("organisation");
        if (!organisationId) return;

        const res = await getAPI.get(`organisations/email_domains/`);
        if (res.status === 200) {
          const results = res.data?.results || [];
          // Filter results by organisation ID
          this.availableEmailDomains = results.filter(
            (item) => item.organisation === organisationId
          );
        }
      } catch (error) {
        console.error("Error fetching email domains:", error);
        this.alertString = `Erreur lors de la récupération des domaines d'e-mail|alert-no|5000::` + Date.now();
      }
    },
    
    async saveSSOConfiguration() {
      if (!this.selectedProvider) return;
      this.savingSSO = true;
      try {
        await this.persistSSOConfiguration();
    
        this.alertString =
          `Configuration SSO enregistrée |alert-yes|5000::` + Date.now();
        this.getOrganisationData();
    
        // Only show Add Domain / LDAP configuration when LDAP is selected
        if (this.selectedProvider === "ldap") {
          this.showLDAPModal = true;
        }
      } catch (error) {
        const apiError = error?.response?.data;
        let msg =
          apiError?.error ||
          apiError?.message ||
          error?.message ||
          "Erreur lors de l'enregistrement";
        if (
          apiError?.code === "unique_violation" ||
          /already configured/i.test(apiError?.error || "")
        ) {
          msg = "Organisation déjà configurée pour SSO";
        }
        this.alertString = `${msg}|alert-no|5000::` + Date.now();
      } finally {
        this.savingSSO = false;
      }
    },
    
    async saveLDAPConfiguration() {
      // Validate required fields
      if (
        !this.ldapConfig.ldap_server_uri ||
        !this.ldapConfig.ldap_bind_dn ||
        !this.ldapConfig.ldap_bind_password ||
        !this.ldapConfig.ldap_user_search_base ||
        !this.ldapConfig.ldap_user_search_filter
      ) {
        this.alertString =
          `${this.$t("fill_all_required_fields")} |alert-no|5000::` +
          Date.now();
        return;
      }
    
      this.savingLDAP = true;
      try {
        // Ensure base SSO configuration is saved before storing LDAP specifics
        if (this.selectedProvider !== "ldap") {
          this.selectedProvider = "ldap";
        }
        await this.persistSSOConfiguration();
    
        const ldapPayload = {
          organisation: localStorage.getItem("organisation"),
          sso_configuration: this.ssoConfigurationId,
          ldap_server_uri: this.ldapConfig.ldap_server_uri,
          ldap_bind_dn: this.ldapConfig.ldap_bind_dn,
          ldap_bind_password: this.ldapConfig.ldap_bind_password,
          ldap_user_search_base: this.ldapConfig.ldap_user_search_base,
          ldap_user_search_filter: this.ldapConfig.ldap_user_search_filter,
          use_ssl: this.ldapConfig.use_ssl,
          use_tls: this.ldapConfig.use_tls,
        };
    
        const ldapRes = await getAPI.post("sso/ldap-config/", ldapPayload);
    
        if (ldapRes.status === 200 || ldapRes.status === 201) {
          this.alertString =
            `Configuration LDAP enregistrée avec succès |alert-yes|5000::` +
            Date.now();
          this.showLDAPModal = false;
          // Reset LDAP config form
          this.ldapConfig = {
            ldap_server_uri: "",
            ldap_bind_dn: "",
            ldap_bind_password: "",
            ldap_user_search_base: "",
            ldap_user_search_filter: "",
            use_ssl: false,
            use_tls: false,
          };
          // Refresh organisation data
          this.getOrganisationData();
          // Open modal to add domain
          this.showSSODomainModal = true;
        } else {
          this.alertString =
            `Impossible d'enregistrer la configuration LDAP |alert-no|5000::` +
            Date.now();
        }
      } catch (error) {
        const apiError = error?.response?.data;
        let msg =
          apiError?.error ||
          apiError?.message ||
          error?.message ||
          "Erreur lors de l'enregistrement de la configuration LDAP";
        this.alertString = `${msg}|alert-no|5000::` + Date.now();
      } finally {
        this.savingLDAP = false;
      }
    },
    
    async onProviderChange() {
      // When LDAP is selected, automatically persist the base configuration and show the modal
      if (this.selectedProvider === "ldap") {
        this.showLDAPModal = true;
        try {
          this.savingSSO = true;
          await this.persistSSOConfiguration();
        } catch (error) {
          const apiError = error?.response?.data;
          let msg =
            apiError?.error ||
            apiError?.message ||
            error?.message ||
            "Impossible d'enregistrer la configuration LDAP";
          this.alertString = `${msg}|alert-no|5000::` + Date.now();
        } finally {
          this.savingSSO = false;
        }
      } else {
        // Close modal if switching away from LDAP
        this.showLDAPModal = false;
      }
    },
    
    async updateSSOConfiguration() {
      if (!this.selectedProvider) return;
      this.savingSSO = true;
      try {
        await this.persistSSOConfiguration();
        this.alertString =
          `Configuration SSO mise à jour |alert-yes|5000::` + Date.now();
        this.getOrganisationData();
    
        if (this.selectedProvider === "ldap") {
          this.showLDAPModal = true;
        }
      } catch (error) {
        const apiError = error?.response?.data;
        const msg =
          apiError?.error ||
          apiError?.message ||
          error?.message ||
          "Erreur lors de la mise à jour";
        this.alertString = `${msg}|alert-no|5000::` + Date.now();
      } finally {
        this.savingSSO = false;
      }
    },
    
    async addDomain() {
      if (!this.selectedDomainToAdd) return;

      const organisationId = localStorage.getItem("organisation");
      if (!organisationId) {
        this.alertString =
          `ID de l'organisation non trouvé|alert-no|5000::` + Date.now();
        return;
      }

      // Check if domain already exists in the list
      const existingDomain = this.availableEmailDomains.find(
        (d) => d.domain.toLowerCase() === this.selectedDomainToAdd.toLowerCase()
      );

      if (existingDomain) {
        this.alertString = `Ce domaine existe déjà|alert-no|5000::` + Date.now();
        return;
      }

      try {
        const payload = {
          domain: this.selectedDomainToAdd
        };
        const res = await getAPI.post(`organisations/email_domains/`, payload);
        if (res.status === 201 || res.status === 200) {
          // Refresh available domains list
          await this.fetchEmailDomains();
          this.selectedDomainToAdd = null; // Clear input
          this.alertString = `Domaine ajouté avec succès|alert-yes|5000::` + Date.now();
        }
      } catch (error) {
        console.error("Error adding organization email domain:", error);
        const apiError = error?.response?.data;
        let msg = "Erreur lors de l'ajout du domaine à l'organisation";

        if (apiError?.errors && Array.isArray(apiError.errors) && apiError.errors.length > 0) {
          const firstErrorObj = apiError.errors[0];
          const domainKey = Object.keys(firstErrorObj)[0];
          const domainError = firstErrorObj[domainKey]?.domain;
          if (Array.isArray(domainError) && domainError.length > 0) {
            msg = domainError[0];
          }
        } else if (apiError?.error || apiError?.message) {
          msg = apiError.error || apiError.message;
        }

        this.alertString = `${msg}|alert-no|5000::` + Date.now();
      }
    },

    async confirmAddSSODomain(domainId, domainValue) {
      if (!domainId) return;
      
      const organisationId = localStorage.getItem("organisation");
      if (!organisationId) {
        this.alertString = `ID de l'organisation non trouvé|alert-no|5000::` + Date.now();
        return;
      }

      try {
        const payload = {
          domain: domainValue,
        };
        const res = await getAPI.put(`organisations/email_domains/${domainId}/`, payload);
        
        if (res.status === 200) {
          this.domains.push(res.data);
          this.selectedDomainToAdd = null; // Reset selection
          this.alertString = `Domaine ajouté avec succès|alert-yes|5000::` + Date.now();
        }
      } catch (error) {
        console.error("Error adding SSO domain:", error);
        const apiError = error?.response?.data;
        let msg = "Erreur lors de l'ajout du domaine";

        if (apiError?.errors && Array.isArray(apiError.errors) && apiError.errors.length > 0) {
          const firstErrorObj = apiError.errors[0];
          const domainKey = Object.keys(firstErrorObj)[0];
          const domainError = firstErrorObj[domainKey]?.domain;
          if (Array.isArray(domainError) && domainError.length > 0) {
            msg = domainError[0];
          }
        } else if (apiError?.error || apiError?.message) {
          msg = apiError.error || apiError.message;
        }

        this.alertString = `${msg}|alert-no|5000::` + Date.now();
      }
    },
    
    async removeDomain(index) {
      const item = this.domains[index];
      const domainId = item && item.id ? item.id : null;
      const domainValue = item && item.domain ? item.domain : null;
      // If we have an id, call the API to remove; otherwise just update UI
      if (domainId) {
        try {
          // API requires PUT for removal with domain in payload
          const payload = {
            domain: domainValue
          };
          await getAPI.put(
            `organisations/email_domains/${domainId}/`,
            payload
          );
          this.domains.splice(index, 1);
        } catch (error) {
          console.error("Error removing SSO domain:", error);
          const msg =
            error?.response?.data?.message ||
            error?.message ||
            "Erreur lors de la suppression du domaine";
          this.alertString = `${msg}|alert-no|5000::` + Date.now();
        }
      } else {
        // Fallback: remove locally if no id present
        this.domains.splice(index, 1);
      }
    },

    openEditDomainModal(domain) {
      this.editingDomain = {
        id: domain.id,
        domain: domain.domain
      };
      this.editDomainModal = true;
      this.exitEditDomainModal = null;
    },

    openDeleteDomainModal(domain) {
      this.deletingDomain = {
        id: domain.id,
        domain: domain.domain
      };
      this.deleteDomainModal = true;
      this.exitDeleteDomainModal = null;
    },

    async updateEmailDomain() {
      if (!this.editingDomain.id || !this.editingDomain.domain) {
        this.alertString = `Données invalides|alert-no|5000::` + Date.now();
        return;
      }

      try {
        const payload = {
          domain: this.editingDomain.domain
        };
        const res = await getAPI.put(
          `organisations/email_domains/${this.editingDomain.id}/`,
          payload
        );

        if (res.status === 200) {
          // Update the domain in the list
          const index = this.availableEmailDomains.findIndex(
            d => d.id === this.editingDomain.id
          );
          if (index !== -1) {
            this.availableEmailDomains[index].domain = this.editingDomain.domain;
          }
          this.editDomainModal = false;
          this.editingDomain = { id: null, domain: "" };
          this.alertString = `Domaine mis à jour avec succès|alert-yes|5000::` + Date.now();
          // Refresh the list
          await this.fetchEmailDomains();
        }
      } catch (error) {
        console.error("Error updating email domain:", error);
        const apiError = error?.response?.data;
        let msg = "Erreur lors de la mise à jour du domaine";

        if (apiError?.errors && Array.isArray(apiError.errors) && apiError.errors.length > 0) {
          const firstErrorObj = apiError.errors[0];
          const domainKey = Object.keys(firstErrorObj)[0];
          const domainError = firstErrorObj[domainKey]?.domain;
          if (Array.isArray(domainError) && domainError.length > 0) {
            msg = domainError[0];
          }
        } else if (apiError?.error || apiError?.message) {
          msg = apiError.error || apiError.message;
        }

        this.alertString = `${msg}|alert-no|5000::` + Date.now();
      }
    },

    async confirmDeleteDomain() {
      if (!this.deletingDomain.id) {
        this.alertString = `ID du domaine non trouvé|alert-no|5000::` + Date.now();
        return;
      }

      try {
        const res = await getAPI.delete(
          `organisations/email_domains/${this.deletingDomain.id}/`
        );

        if (res.status === 200 || res.status === 204) {
          // Remove the domain from the list
          const index = this.availableEmailDomains.findIndex(
            d => d.id === this.deletingDomain.id
          );
          if (index !== -1) {
            this.availableEmailDomains.splice(index, 1);
          }
          this.deleteDomainModal = false;
          this.deletingDomain = { id: null, domain: "" };
          this.alertString = `Domaine supprimé avec succès|alert-yes|5000::` + Date.now();
          // Refresh the list
          await this.fetchEmailDomains();
        }
      } catch (error) {
        console.error("Error deleting email domain:", error);
        const apiError = error?.response?.data;
        const msg =
          apiError?.error ||
          apiError?.message ||
          error?.message ||
          "Erreur lors de la suppression du domaine";
        this.alertString = `${msg}|alert-no|5000::` + Date.now();
      }
    },

    async updateAllAccess(e) {
      const newValue = e.target.checked;
      console.log("New Value: ", newValue);
      this.togglePluzzModule(newValue);
      // this.moduleToUpdateAll = module.access_type === "ALL" && module.statut === "available" ? true : false
    },

    async updateModulePluzzTarget(visibility = true) {
      this.isUpdatingPluzz = true;
      console.log("Module Pluzz Selectionné: ", this.selectedPluzz.activated);
      await getAPI
        .patch(
          `module_pluzz/make_module_pluzz_visible/${this.selectedPluzz.id}?is_visible=${visibility}`,
          {
            access_type: this.activePluzzTab === "groups" ? "GROUP" : "SERVICE",
            service_ids:
              this.activePluzzTab === "services"
                ? this.selectedPluzz.services
                : [],
            group_ids:
              this.activePluzzTab === "groups" ? this.selectedPluzz.groups : [],
          }
        )
        .then(async (response) => {
          console.log(response);
          this.updatePluzzTargetBox = false;
          await this.getModulePluzz();
          this.alertString =
            "Module assigné avec succès|alert-yes|5000::" + Date.now();
        })
        .catch((error) => {
          console.error("Error updating module pluzz targets:", error);
          this.alertString =
            "Erreur lors de l'assignation du module|alert-no|5000::" +
            Date.now();
        })
        .finally(() => {
          this.isUpdatingPluzz = false;
        });
    },
    
    // SSO toggle method
    async toggleSSOStatus() {
      if (this.ssoToggleLoading) return;
      const orgId = localStorage.getItem("organisation");
      if (!orgId) {
        this.alertString =
          `Organisation introuvable|alert-no|4000::` + Date.now();
        return;
      }
    
      const nextState = !this.ssoEnabled;
    
      // If enabling SSO, require a provider to be selected first
      if (nextState && !this.selectedProvider) {
        this.alertString =
          `Sélectionnez un fournisseur SSO et cliquez sur "Configurer SSO" avant d'activer|alert-no|5000::` +
          Date.now();
        return;
      }
    
      this.ssoToggleLoading = true;
      try {
        const endpoint = nextState
          ? `organisations/enable_sso/${orgId}/`
          : `organisations/disable_sso/${orgId}/`;
        const res = await getAPI.post(endpoint);
        if (res?.status === 200 || res?.status === 201) {
          this.ssoEnabled = nextState;
          // Refresh organisation data to get updated sso_enabled status
          this.getOrganisationData();
          this.alertString =
            `${nextState ? "SSO activé" : "SSO désactivé"}|alert-yes|4000::` +
            Date.now();
        } else {
          this.alertString =
            `Action SSO non appliquée|alert-no|4000::` + Date.now();
        }
      } catch (error) {
        const apiError = error?.response?.data;
        const msg =
          apiError?.error ||
          apiError?.message ||
          error?.message ||
          "Erreur lors du changement de statut SSO";
        this.alertString = `${msg}|alert-no|5000::` + Date.now();
      } finally {
        this.ssoToggleLoading = false;
      }
    },

    // MS Teams Credentials Methods
    async fetchTeamsCredentials() {
      this.loadingTeams = true;
      try {
        const res = await getAPI.get("micro_learning/teams-credentials/");
        if (res.status === 200 && res.data && res.data.results && res.data.results.length > 0) {
          const creds = res.data.results[0];
          this.teamsCredentials = {
            id: creds.id,
            client_id: creds.client_id,
            client_secret: creds.client_secret,
            tenant_id: creds.tenant_id,
            sender_user_id: creds.sender_user_id,
          };
        } else {
          this.teamsCredentials = {
            id: null,
            client_id: "",
            client_secret: "",
            tenant_id: "",
            sender_user_id: "",
          };
        }
      } catch (error) {
        console.error("Error fetching MS Teams credentials:", error);
      } finally {
        this.loadingTeams = false;
      }
    },

    async saveTeamsCredentials() {
      this.savingTeams = true;
      try {
        const payload = {
          client_id: this.teamsCredentials.client_id,
          client_secret: this.teamsCredentials.client_secret,
          tenant_id: this.teamsCredentials.tenant_id,
          sender_user_id: this.teamsCredentials.sender_user_id,
        };

        let res;
        if (this.teamsCredentials.id) {
          // Update
          res = await getAPI.patch(`micro_learning/teams-credentials/${this.teamsCredentials.id}/`, payload);
          if (res.status === 200) {
            this.alertString = `${this.$t("ms_teams_update_success")}|alert-yes|5000::` + Date.now();
            this.showTeamsModal = false;
          }
        } else {
          // Create
          res = await getAPI.post("micro_learning/teams-credentials/", payload);
          if (res.status === 201 || res.status === 200) {
            this.alertString = `${this.$t("ms_teams_save_success")}|alert-yes|5000::` + Date.now();
            this.teamsCredentials.id = res.data.id;
            this.showTeamsModal = false;
          }
        }
        await this.fetchTeamsCredentials();
      } catch (error) {
        console.error("Error saving MS Teams credentials:", error);
        this.alertString = "Erreur lors de l'enregistrement|alert-no|5000::" + Date.now();
      } finally {
        this.savingTeams = false;
      }
    },

    async deleteTeamsCredentials() {
      if (!this.teamsCredentials.id) return;
      try {
        const res = await getAPI.delete(`micro_learning/teams-credentials/${this.teamsCredentials.id}/`);
        if (res.status === 200 || res.status === 204) {
          this.alertString = `${this.$t("ms_teams_delete_success")}|alert-yes|5000::` + Date.now();
          this.teamsCredentials = {
            id: null,
            client_id: "",
            client_secret: "",
            tenant_id: "",
            sender_user_id: "",
          };
          this.showTeamsDeleteModal = false;
          this.showTeamsModal = false;
        }
      } catch (error) {
        console.error("Error deleting MS Teams credentials:", error);
        this.alertString = "Erreur lors de la suppression|alert-no|5000::" + Date.now();
      }
    },
  },
  mounted() {
    this.getDashboardData();
    this.getModule();
    this.getModulePluzz();
    this.retrieveUserSubscription();
    this.getOrganisationData();
    this.retrieveUserTransactions();
    this.getManagerNotice();
    this.getActivities();
    this.getActivityOptions();
    this.getGroupes();
    this.getServices();
    this.getCustomReminderTemplate();
    this.fetchTeamsCredentials();
    // this.moduleToUpdateAll = module.accesss_type === "ALL" && module.statut === "availaible" ? true : false;
  },
  watch: {
    dateEnd: function (value) {
      this.waitingAPIResponse = true;
      getAPI
        .patch(`organisations/${localStorage.organisation}/`, {
          deadline_training: value,
        })
        .then((response) => {
          if (response.status == 200) {
            this.subscriptionData = response.data;
            this.retrieveUserSubscription();
          } else {
            ////let msg = 'Oups ! something went wrong.'
            ////this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          setTimeout(() => {
            this.waitingAPIResponse = false;
          }, 2000);
        })
        .catch((error) => {
          if (error.response) {
            //this.alertString = `${error.response.data.message}|alert-no|10000::`+Date.now()
          } else if (error.request) {
            //let msg = 'The request was made but no response was received. Please check your network.'
            //this.alertString = `${msg}|alert-no|8000::`+Date.now()
          } else {
            ////let msg = 'Oups ! something went wrong.'
            ////this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          this.waitingAPIResponse = false;
        });
    },
    "selectedPluzz.groups": {
      handler(newVal) {
        // Si on sélectionne des groupes, basculer automatiquement sur l'onglet groupes
        if (newVal.length > 0) {
          if (this.activePluzzTab === "services") {
            this.activePluzzTab = "groups";
          }
          // Désactiver "Activer pour tous les utilisateurs" si des groupes sont sélectionnés
          // if (this.moduleToUpdateAll) {
          //   this.moduleToUpdateAll = false;
          // }
        }
      },
      deep: true,
    },
    "selectedPluzz.services": {
      handler(newVal) {
        // Si on sélectionne des services, basculer automatiquement sur l'onglet services
        if (newVal.length > 0) {
          if (this.activePluzzTab === "groups") {
            this.activePluzzTab = "services";
          }
          // Désactiver "Activer pour tous les utilisateurs" si des services sont sélectionnés
          // if (this.moduleToUpdateAll) {
          //   this.moduleToUpdateAll = false;
          // }
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
//@import "../../assets/scss/tailwinds.scss";

/* General styles for the toggle switch container */
.toggle-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

/* The hidden checkbox input */
.toggle-input {
  display: none;
}

/* The track (background of the toggle) */
.toggle-track {
  width: 2.75rem; /* 11 * 0.25rem */
  height: 1.5rem; /* 6 * 0.25rem */
  background-color: #e5e7eb; /* bg-gray-200 */
  border-radius: 9999px; /* rounded-full */
  position: relative;
  outline: none;
  transition: background-color 0.3s ease;
}

/* Focus ring */
.toggle-input:focus + .toggle-track {
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.3); /* ring-4 + ring-blue-300 */
}

/* The thumb (the circular knob) */
.toggle-thumb {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 1.25rem; /* 5 * 0.25rem */
  height: 1.25rem; /* 5 * 0.25rem */
  background-color: #fff; /* bg-white */
  border: 1px solid #d1d5db; /* border-gray-300 */
  border-radius: 9999px; /* rounded-full */
  transition: all 0.3s ease; /* after:transition-all */
}

/* Checked state styles */
.toggle-input:checked + .toggle-track {
  background-color: #2563eb; /* bg-blue-600 */
}

.toggle-input:checked + .toggle-track .toggle-thumb {
  transform: translateX(100%);
  border-color: #fff; /* after:border-white */
}

.entreprise-block {
  min-height: 15.5em;
}

.time-block {
  min-height: 13em;
}

.license-block {
  min-height: 30.3em;
}

.cfa-block {
  background-color: #fff;
  border-radius: 0.5em;
  padding: 0.5em 1em;
  box-shadow: -1px 1px 29px 20px rgba(222, 234, 250, 0.87);
  -webkit-box-shadow: -1px 1px 29px 20px rgba(222, 234, 250, 0.87);
  -moz-box-shadow: -1px 1px 29px 20px rgba(222, 234, 250, 0.87);

  /* border: 1px solid transparent;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05); */
}

.ticket-list tr {
  border-color: transparent !important;
}

.codeStyle {
  padding: 0.5em;
  background: #f5eded;
  text-decoration: none;
  color: var(--primary-color);
  font-weight: 400;
  display: inline-block;
  cursor: copy;
}

.gFolder-container {
  background-color: #cef1f3;
  border-radius: 0.5em;
  height: 4.3em;
  width: 4.6em;
  margin-right: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gBlock {
  align-items: center;
  justify-content: start;
  border-radius: 0.6em;
  padding-left: 2em;
  padding-right: 2em;
  height: 8em !important;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
  background-image: url("https://laravel.pixelstrap.com/cuba/build/assets/widget-bg-a2f1cbe6.png");
  background-size: cover;
}

.gBlock2 {
  align-items: center;
  justify-content: start;
  border-radius: 0.6em;
  padding-left: 2em;
  padding-right: 2em;
  height: 18.5em !important;
  box-shadow: none;
  background-image: none !important;
  background-color: #cef1f3 !important;
}

.gBlock div:last-of-type p {
  margin: 0;
}

.gBlock div:last-of-type p:first-of-type {
  font-weight: 400;
  font-size: 1.4em;
}

.welcome-card {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: #132b4d;
}

.card {
  margin-bottom: 20px;
  border: none;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  border-radius: 15px;
  box-shadow: 0 9px 20px #2e235e12;
}

.o-hidden {
  overflow: hidden;
}

.card .card-body {
  padding: 20px;
  background-color: transparent;
}

.welcome-card .welcome-img {
  height: 100%;
  position: absolute;
  right: 0;
  bottom: -5px;
}

@media (max-width: 1700px) {
  .welcome-card .welcome-img {
    bottom: -5px;
  }
}

@media (max-width: 1780px) {
  .welcome-card .welcome-img {
    height: 100%;
    bottom: -5px;
  }
}

.course-box {
  overflow: hidden;
  min-height: 170px !important;
}

.square-group {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: scaleX(-1);
}

ul {
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
}

.square-group .warning {
  background: #c8fcff;
}

.square-group .square-1 {
  width: 12px;
  height: 18px;
}

.square-group .primary {
  background: var(--primary-color);
}

.square-group .warning1 {
  background: #ffd497;
}

.square-group .danger {
  background: #f54132;
}

.square-group .light {
  background: #e6e8ef;
}

.square-group .warning {
  background: #c8fcff;
}

.square-group .success {
  background: #54ba4a;
}

.square-group .square-6,
.square-group .square-7 {
  position: absolute;
  width: 4px;
  height: 4px;
}

.square-group .square-6,
.square-group .square-7 {
  position: absolute;
  width: 4px;
  height: 4px;
}

.square-group .success {
  background: #54ba4a;
}

.course-widget {
  display: flex;
  gap: 8px;
}

.course-widget .course-icon {
  position: relative;
  width: 54px;
  height: 54px;
  clip-path: polygon(
    40% 7.67949%,
    43.1596% 6.20615%,
    46.52704% 5.30384%,
    50% 5%,
    53.47296% 5.30384%,
    56.8404% 6.20615%,
    60% 7.67949%,
    81.65064% 20.17949%,
    84.50639% 22.17911%,
    86.97152% 24.64425%,
    88.97114% 27.5%,
    90.44449% 30.6596%,
    91.34679% 34.02704%,
    91.65064% 37.5%,
    91.65064% 62.5%,
    91.34679% 65.97296%,
    90.44449% 69.3404%,
    88.97114% 72.5%,
    86.97152% 75.35575%,
    84.50639% 77.82089%,
    81.65064% 79.82051%,
    60% 92.32051%,
    56.8404% 93.79385%,
    53.47296% 94.69616%,
    50% 95%,
    46.52704% 94.69616%,
    43.1596% 93.79385%,
    40% 92.32051%,
    18.34936% 79.82051%,
    15.49361% 77.82089%,
    13.02848% 75.35575%,
    11.02886% 72.5%,
    9.55551% 69.3404%,
    8.65321% 65.97296%,
    8.34936% 62.5%,
    8.34936% 37.5%,
    8.65321% 34.02704%,
    9.55551% 30.6596%,
    11.02886% 27.5%,
    13.02848% 24.64425%,
    15.49361% 22.17911%,
    18.34936% 20.17949%
  );
  background: linear-gradient(310.31deg, #ff3364 14.71%, #ff7f9e 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.f-light {
  color: #52526c;
  opacity: 0.8;
}

.no-wrap {
  white-space: nowrap;
}

.course-widget .btn-light {
  background: #f2f3f7 !important;
  border: none;
}

.course-widget a {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  position: relative;
  margin-top: 5px;
  top: 8px;
}

.card {
  margin-bottom: 20px;
  border: none;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  border-radius: 7px;
  box-shadow: 0 9px 20px #2e235e12;

  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  min-height: 130px;
}

.card .card-header.card-no-border {
  border-bottom: none !important;
}

.get-card .card-header {
  padding-left: 20px;
  padding-right: 20px;
}

.card .card-header {
  background-color: #fff;
  padding: 30px;
  border-bottom: 1px solid #ecf3fa;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  position: relative;
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.card .card-body {
  padding: 30px;
  background-color: transparent;
}

.btn-outline-white {
  border: 1px solid #132b4d;
  color: #132b4d;

  &:hover {
    background-color: #132b4d;
    color: white;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

/* Pluzz Modal Styles */
.pluzz-modal-header {
  margin-bottom: 1.5rem;
}

.pluzz-modal-body {
  max-height: 50vh;
  overflow-y: auto;
}

.pluzz-tabs-container {
  display: flex;
  gap: 0.5rem;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 0;
}

.pluzz-tab-button {
  padding: 0.75rem 1.5rem;
  border: none;
  background: transparent;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  font-weight: 500;
  position: relative;
  bottom: -2px;

  &:hover:not(:disabled) {
    color: var(--primary-color);
    background-color: rgba(0, 0, 0, 0.02);
  }

  &.active {
    color: var(--primary-color);
    border-bottom-color: var(--primary-color);
  }

  &:disabled,
  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    color: #adb5bd;

    &:hover {
      background-color: transparent;
      color: #adb5bd;
    }
  }

  .badge {
    font-size: 0.7rem;
    padding: 0.25rem 0.5rem;
  }
}

.pluzz-tab-content {
  margin-top: 1.5rem;
}

.tab-pane-content {
  min-height: 300px;
  max-height: 400px;
  overflow-y: auto;
}

.selection-list-pluzz {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 12px;
}

.pluzz-selection-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 2px solid #e9ecef;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #fff;

  &:hover {
    border-color: var(--primary-color);
  }

  &.selected {
    border-color: var(--primary-color);
    background-color: rgba(var(--primary-color-rgb), 0.1);
  }
}

.pluzz-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 1rem;
  flex-shrink: 0;
  accent-color: var(--primary-color);
}

.pluzz-label {
  flex: 1;
  cursor: pointer;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pluzz-item-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.pluzz-item-name {
  font-size: 1rem;
  color: #212529;
  font-weight: 600;
}

.empty-state-pluzz {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  color: #6c757d;
  min-height: 250px;
}

.pluzz-selection-summary {
  border: 1px solid #e9ecef;
  font-size: 0.95rem;

  .text-primary {
    color: var(--primary-color) !important;
  }
}

.pagination {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    list-style: none;
  }

  .btn-sm {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }
}

.modal-footer {
  margin-top: 2rem;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;

  .btn {
    min-width: 150px;
  }
}

.cfa-btn-primary {
  background-color: var(--primary-color);
  color: white;

  &:hover {
    background: #09a4ac;
    box-shadow: 0 2px 8px rgba(11, 187, 196, 0.3);
    transform: translateY(-1px);
    color: #fff;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}
</style>
